
import React, { useState, useEffect, useRef, useCallback, useReducer } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Notifications, Help, ArrowDropDown, Upload, UploadFileOutlined } from '@mui/icons-material';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Badge,
  Box,
  Autocomplete,
  Select,
  Divider,
  Drawer,
  TextField,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper,
  Tooltip
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Search from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from '@mui/icons-material/Clear';
import ManageKeywords from './ManageKeywords';
import ToggleSplitPane from '../components/ToggleSplitPane';
import PdfViewerComponent from './PdfViewerComponent';
import AlertNotification from '../components/AlertNotification';

import {
  TextFieldWithIconButton,
  UtilityLibrary,
  ApiManager,
  batchDataService,
  BusinessUtility,
  DebounceForm,
  ValidateRequiredFieldsInForm,
  sessionService,
  SessionManager,
  PageLoader,
  DocumentUtility,
  EnumUtility,
  LoggerUtility,
  ConfirmationDialog,
  NotificationDialog,
  DeterminePermissions,
  SharedService,
  ClientType
} from '../components/ComponentsLibrary';
import { findAllByDisplayValue } from '@testing-library/react';

import { useNavigationContext } from '../functions/NavigationContext';
import { useConfigContext } from '../functions/ConfigContext';


const DocumentSearch = ({ batch, handleBatchChange }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setActivePage } = useNavigationContext();
  const { configLibrary } = useConfigContext();

  const { mainTitle, formTitle, viewOnly } = location.state || EnumUtility.DocumentSearchPageProperty.DocumentSearch;

  const documentSearchPageTitle = 'YTrac :: ' + mainTitle;
  const manageKeywordsPageTitle = 'YTrac :: Manage Keywords';
  const [pageTitleCurrent, setPageTitleCurrent] = useState(documentSearchPageTitle);

  useEffect(() => {
    setLeftPaneTitle(mainTitle);
    setPageTitleCurrent(documentSearchPageTitle);
  }, [mainTitle]);

  useEffect(() => {
    document.title = pageTitleCurrent;
  }, [pageTitleCurrent]);

  const errorFormName = "Document Search";

  const masterServerDBSchema = SessionManager.GetDataFromSession("SiteSettingsDetailsKey")?.masterDBSchema;

  const [leftPaneTitle, setLeftPaneTitle] = useState(mainTitle);
  const [rightPaneTitle, setRightPaneTitle] = useState("Document Viewer");

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmationDialogContent, setConfirmationDialogContent] = useState([]);

  const [notificationDialogOpen, setNotificationDialogOpen] = useState(false);
  const [notificationDialogContent, setNotificationDialogContent] = useState([]);
  const [timerNotificationDialogClose, setTimerNotificationDialogClose] = useState(5000);
  const [timerAutoCloseNotificationDialog, setTimerAutoCloseNotificationDialog] = useState(false);
  const [notificationDialogPosition, setNotificationDialogPosition] = useState("center")

  // Create a ref for the child component
  const pdfViewerRef = useRef(null);
  const [splitArgs, setSplitArgs] = useState(null);
  const [pendingEditorCloseAction, setPendingEditorCloseAction] = useState(null);

  const [isSearchEnabled, setIsSearchEnabled] = useState(true);
  const [importStartDateValidationMessage, setImportStartDateValidationMessage] = useState("");
  const [importEndDateValidationMessage, setImportEndDateValidationMessage] = useState("");
  const [indexStartDateValidationMessage, setIndexStartDateValidationMessage] = useState("");
  const [indexEndDateValidationMessage, setIndexEndDateValidationMessage] = useState("");

  const [resultsDocs, setDocResults] = useState([]);
  const [hasSearchResults, setHasSearchResults] = useState(false);
  const [pageCurrent, setPageCurrent] = useState(0); // State to control the current page
  const [pageSize, setPageSize] = useState(5); // State to control the page size
  const [paginationModel, setPaginationModel] = useState({ pageSize: 5, page: 0 });
  const [initialSearch, setInitialSearch] = useState(false);
  const [gridFilterModel, setGridFilterModel] = useState({ items: [] });
  const [isPageLoading, setIsPageLoading] = useState(false);


  const [uncDocumentUrl, setUncDocumentUrl] = useState('');
  const [enableShowDocument, setEnableShowDocument] = useState(false);
  const [documentUrl, setDocumentUrl] = useState('');
  const [selectedDoc, setSelectedDoc] = useState({});
  const [selectedDocData, setSelectedDocData] = useState({});
  const [caseBatchDocumentID, setCaseBatchDocumentID] = useState(0);
  const [enableManageKeywords, setEnableManageKeywords] = useState(false);
  const [showCasesByBatchDoc, setShowCasesByBatchDoc] = useState(false);

  const [testDocLoad, setTestDocLoad] = useState(false);

  const customDateFormat = "MM/DD/YYYY hh:mm:ss A";

  const defaultPermissionsForFields = {
    importStartDateTxt: { read: false, write: true, hide: false },
    importEndDateTxt: { read: false, write: true, hide: false },
    indexStartDateTxt: { read: false, write: true, hide: false },
    indexEndDateTxt: { read: false, write: true, hide: false },
    caseNumberTxt: { read: false, write: true, hide: false },
    batchNumberTxt: { read: false, write: true, hide: false },
    docGroupSelect: { read: false, write: true, hide: false },
    docTypeSelect: { read: false, write: true, hide: false },
    documentSourceSelect: { read: false, write: true, hide: false },
    indexBySelect: { read: false, write: true, hide: false },
    documentsDgrd: { read: false, write: true, hide: false },
    cancelBtn: { read: false, write: true, hide: false },
    searchBtn: { read: false, write: true, hide: false },
    manageKeywordsBtn: { read: false, write: true, hide: false },
    documentViewerVwr: { read: false, write: true, hide: false },
    docVwrEditor: { read: false, write: true, hide: false },
    docVwrToolbarItems: { read: false, write: true, hide: false },
    docVwrRotateBtn: { read: false, write: true, hide: false },
    docVwrSplitBtn: { read: false, write: true, hide: false },
    docVwrDeleteBtn: { read: false, write: true, hide: false },
    docVwrSaveBtn: { read: false, write: true, hide: false },
    docVwrCopyPathBtn: {read: false, write: true, hide: false},
    caseNumberLbl: { read: false, write: true, hide: false },
    cpNameLbl: { read: false, write: true, hide: false },
    ncpNameLbl: { read: false, write: true, hide: false },
    viewAllDocumentsChk: { read: false, write: true, hide: false },
  };
  const [formFieldAccess, setFormFieldAccess] = useState(defaultPermissionsForFields);

  const documentViewerAccessPermissions = {
    viewOnlyAccess: viewOnly,
    editorAccess: formFieldAccess.docVwrEditor,
    viewerToolbarItemsAccess: formFieldAccess.docVwrToolbarItems,
    rotateButtonAccess: formFieldAccess.docVwrRotateBtn,
    splitButtonAccess: formFieldAccess.docVwrSplitBtn,
    deleteButtonAccess: formFieldAccess.docVwrDeleteBtn,
    saveButtonAccess: formFieldAccess.docVwrSaveBtn,
  };

  // Initial state for the form fields
  const initialFormData = {
    hasValidCaseData: true,
    hasValidDateData: true,
    importStartDateTxt: "",
    importEndDateTxt: "",
    indexStartDateTxt: "",
    indexEndDateTxt: "",
    caseSearch: "",
    batchNumberTxt: "",
    docGroupSelect: "",
    docTypeSelect: "",
    documentSourceSelect: "",
    indexBySelect: "",
    viewAllDocuments: false
  };
  const [searchFormData, setSearchFormData] = useState(initialFormData);

  const caseNumberRef = useRef();
  // Validation patterns
  const siteSettingDetail = JSON.parse(SessionManager.GetValueFromSession(SessionManager.SiteSettingsDetailsKey));
  const caseNumberRegex = siteSettingDetail.CaseNumberRegex || { caseRegexValue: "", caseRegexMessage: "" };
  const docViewerLicenseKey = siteSettingDetail.DocViewerLicenseKey || "";
  const timeZone = SessionManager.GetDataFromSession("LoginUserInfoKey")?.timeZone;
  const softLockTimer = parseInt(siteSettingDetail.SoftLockTimer, 10) || 30;
  const batchDocumentStaleLockTimeout = parseInt(siteSettingDetail.BatchDocumentStaleLockTimeout, 10) || 30;
  const mdhsImportSweepProcessID = parseInt(siteSettingDetail.MDHSImportSweepProcessID, 10) || 0;

  const initialCaseNumberIconsDisabled = { copy: false, clear: false };
  const [caseNumberIconsDisabled, setCaseNumberIconsDisabled] = useState(initialCaseNumberIconsDisabled);
  const [disableKeyDownOnCaseSearch, setDisableKeyDownOnCaseSearch] = useState(false);

  const inputDateRefs = useRef({}); // Object to store refs dynamically

  const [caseInfoFormVisibility, setCaseInfoFormVisibility] = useState(false);
  const [currentCaseFormData, setCurrentCaseFormData] = useState([]);

  const FormFieldEnableType = {
    ImportDateSelect: { ID: 100, name: "ImportDateSelect" },
    IndexDateSelect: { ID: 200, name: "IndexDateSelect" }
  };

  const [selectedRadioOption, setSelectedRadioOption] = useState("");
  const [viewAllDocumentsEnabled, setViewAllDocumentsEnabled] = useState(false);

  // Initial state for form fields
  const initialState = {
    importStartDateSelect: false,
    importEndDateSelect: false,
    indexStartDateSelect: false,
    indexEndDateSelect: false,
    viewAllDocumentsCheckbox: false
  };

  const [formState, dispatch] = useReducer(reducer, initialState);

  // Reducer to manage enable/disable state
  function reducer(state, action) {
    switch (action.type) {
      case "SET_FIELD_STATE":
        return { ...state, [action.payload.field]: action.payload.isEnabled };

      default:
        throw new Error("Unknown action type");
    }
  };


  // Function to apply Form Fields Enable logic
  function formFieldsEnableLogic(dispatch, logicType, config = {}) {
    const { viewAllDocuments = false } = config;
    
    if (viewAllDocuments) {
      // When View All Documents is checked, disable all date fields
      dispatch({ type: "SET_FIELD_STATE", payload: { field: "importStartDateSelect", isEnabled: false } });
      dispatch({ type: "SET_FIELD_STATE", payload: { field: "importEndDateSelect", isEnabled: false } });
      dispatch({ type: "SET_FIELD_STATE", payload: { field: "indexStartDateSelect", isEnabled: false } });
      dispatch({ type: "SET_FIELD_STATE", payload: { field: "indexEndDateSelect", isEnabled: false } });
      return;
    }

    switch (logicType) {
      case FormFieldEnableType.ImportDateSelect.ID:
        dispatch({ type: "SET_FIELD_STATE", payload: { field: "importStartDateSelect", isEnabled: true } });
        dispatch({ type: "SET_FIELD_STATE", payload: { field: "importEndDateSelect", isEnabled: true } });
        dispatch({ type: "SET_FIELD_STATE", payload: { field: "indexStartDateSelect", isEnabled: false } });
        dispatch({ type: "SET_FIELD_STATE", payload: { field: "indexEndDateSelect", isEnabled: false } });
        break;
      case FormFieldEnableType.IndexDateSelect.ID:
        dispatch({ type: "SET_FIELD_STATE", payload: { field: "importStartDateSelect", isEnabled: false } });
        dispatch({ type: "SET_FIELD_STATE", payload: { field: "importEndDateSelect", isEnabled: false } });
        dispatch({ type: "SET_FIELD_STATE", payload: { field: "indexStartDateSelect", isEnabled: true } });
        dispatch({ type: "SET_FIELD_STATE", payload: { field: "indexEndDateSelect", isEnabled: true } });
        break;
      default:
        dispatch({ type: "SET_FIELD_STATE", payload: { field: "importStartDateSelect", isEnabled: false } });
        dispatch({ type: "SET_FIELD_STATE", payload: { field: "importEndDateSelect", isEnabled: false } });
        dispatch({ type: "SET_FIELD_STATE", payload: { field: "indexStartDateSelect", isEnabled: false } });
        dispatch({ type: "SET_FIELD_STATE", payload: { field: "indexEndDateSelect", isEnabled: false } });
        break;
    }
  };

  /**************************************************************************** */
  //Document Group dropdown
  const [docGroupList, setDocGroupList] = useState([]);
  const [selectedDocGroup, setSelectedDocGroup] = useState('');

  //Document Type dropdown
  let originalDocType = "";
  const [selectedDocType, setSelectedDocType] = useState("");
  const [documentTypes, setDocumentTypes] = useState([]);

  //Document Source dropdown API code
  const [docSourelists, setDocSourelists] = useState([]);
  const [selectedDocSource, setSelectedDocSource] = useState("");

  //Index By dropdown API code 
  const [indexBylists, setIndexBylists] = useState([]);
  const [selectedIndexBy, setSelectedIndexBy] = useState("");
  /**************************************************************************** */

  // Data for the document grid in view 2
  const documentGridColumns = [
    { field: 'caseNumber', headerName: 'Case Number', flex: 1 },
    { field: 'documentGroupTypeName', headerName: 'Group', flex: 1 },
    { field: 'documentTypeName', headerName: 'Type', flex: 1 },
    { field: 'documentSource', headerName: 'Source', flex: 1 },
    { field: 'indexedBy', headerName: 'Indexed By', flex: 1 },
    { field: 'scanTS', headerName: 'Imported Date', type: 'dateTime', valueFormatter: (value) => value && UtilityLibrary.formatDate(value, customDateFormat), flex: 1 },
    { field: 'indexingCompleteTS', headerName: 'Indexed Date', type: 'dateTime', valueFormatter: (value) => value && UtilityLibrary.formatDate(value, customDateFormat), flex: 1 },
    { field: 'batchDocumentID', headerName: 'ID', flex: 1 }
  ];

  // Add an index to each row
  const resultsDocsWithIndex = resultsDocs.map((row, index) => ({
    ...row,
    rowIndex: index, // Add rowIndex property
  }));

  const [showManageKeywords, setShowManageKeywords] = useState(false);
  
  // State to track when case search should be focused after ManageKeywords save
  const [shouldFocusCaseSearch, setShouldFocusCaseSearch] = useState(false);

  const [alertProps, setAlertProps] = useState({
    type: '',
    message: '',
    open: false,
  });

  const handleAlertClose = () => {
    setAlertProps((prevState) => ({ ...prevState, open: false }));
  };

  const showAlert = (type, message) => {
    setAlertProps({ type, message, open: true });
  };

  const handleBatchLockNotification = (lockAnalysis) => {
    if (!lockAnalysis?.isLockedByOtherUser) {
      return;
    }

    handleNotificationDialog({
      Title: "Warning",
      Message: lockAnalysis.lockMessage,
      NotificationType: EnumUtility.NotificationType.Warning
    });
  };

  const handleBatchDocumentLockNotification = (lockAnalysis) => {
    if (!lockAnalysis?.isLockedByOtherUser) {
      return;
    }

    handleNotificationDialog({
      Title: "Warning",
      Message: lockAnalysis.lockMessage,
      NotificationType: EnumUtility.NotificationType.Warning
    });
  };

  const getBatchIdForSelectedDocument = async () => {
    if (!caseBatchDocumentID) {
      return 0;
    }

    const paramsBatchDoc = { batchDocumentID: caseBatchDocumentID };
    const batchDocApiData = await ApiManager.GetBatchDocumentByIDFromApi(paramsBatchDoc);
    return batchDocApiData?.batchID || 0;
  };

  const checkBatchLockBeforeDocumentAction = async (actionName) => {
    try {
      const batchID = await getBatchIdForSelectedDocument();
      if (!batchID) {
        return { isLocked: false };
      }

      const lockData = await ApiManager.GetBatchLockStatusFromApi({
        batchID,
        masterServerDBSchema,
        softLockTime: softLockTimer
      });

      const loginUserInfo = sessionService.getUser();
      const currentUserId = loginUserInfo ? loginUserInfo.legacyUserID : -123456;
      const analysis = ApiManager.AnalyzeBatchLockStatus(lockData, currentUserId);

      if (analysis.isLockedByOtherUser) {
        handleBatchLockNotification(analysis);
        return { isLocked: true };
      }

      return { isLocked: false };
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, actionName || "checkBatchLockBeforeDocumentAction");
      return { isLocked: false };
    }
  };

  const checkBatchDocumentLockStatus = async (actionName, batchDocumentID = caseBatchDocumentID) => {
    try {
      const activeBatchDocumentID = batchDocumentID || selectedDoc?.batchDocumentID || selectedDocData?.batchDocumentID || caseBatchDocumentID;

      if (!activeBatchDocumentID) {
        return { isLocked: false };
      }

      const loginUserInfo = sessionService.getUser();
      const currentUserId = loginUserInfo ? loginUserInfo.legacyUserID : -123456;

      const lockData = await ApiManager.GetBatchDocumentLockStatusFromApi({
        batchDocumentID: activeBatchDocumentID,
        userLoginID: currentUserId,
        masterServerDBSchema,
        documentStaleLockTimer: batchDocumentStaleLockTimeout
      });

      const analysis = ApiManager.AnalyzeBatchDocumentLockStatus(lockData, currentUserId);

      if (analysis.isLockedByOtherUser) {
        handleBatchDocumentLockNotification(analysis);
        return { isLocked: true };
      }

      return { isLocked: false };
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, actionName || "checkBatchDocumentLockStatus");
      return { isLocked: false };
    }
  };

  const checkAndLockBatchDocumentBeforeEdit = async (actionName, batchDocumentID = caseBatchDocumentID) => {
    try {
      const activeBatchDocumentID = batchDocumentID || selectedDoc?.batchDocumentID || selectedDocData?.batchDocumentID || caseBatchDocumentID;

      const lockStatus = await checkBatchDocumentLockStatus(actionName, activeBatchDocumentID);
      if (lockStatus.isLocked) {
        return lockStatus;
      }

      if (!activeBatchDocumentID) {
        return { isLocked: false };
      }

      const loginUserInfo = sessionService.getUser();
      const currentUserId = loginUserInfo ? loginUserInfo.legacyUserID : -123456;

      await ApiManager.PostBatchDocumentLockStatusToApi({
        batchDocumentID: activeBatchDocumentID,
        lockValue: 1,
        userLoginID: currentUserId,
        masterServerDBSchema
      });

      return { isLocked: false };
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, actionName || "checkAndLockBatchDocumentBeforeEdit");
      return { isLocked: false };
    }
  };

  const getDocumentNameDisplayed = async (documentData) => {
    const batchDocumentData = await ApiManager.GetBatchDocumentByIDFromApi({
      batchDocumentID: documentData.batchDocumentID
    });
    const fallbackDocumentName =
      batchDocumentData?.documentName ??
      batchDocumentData?.DocumentName ??
      documentData.documentName;
    let documentNameDisplayed = fallbackDocumentName;
    const documentSweepProcessID = parseInt(
      batchDocumentData?.sweepProcessID ?? batchDocumentData?.SweepProcessID,
      10
    );

    if (mdhsImportSweepProcessID > 0 && documentSweepProcessID === mdhsImportSweepProcessID) {
      const metadata = await ApiManager.GetMetadataFromApi(
        batchDocumentData?.documentUNCPath ?? documentData.documentUNCPath,
        fallbackDocumentName
      );
      documentNameDisplayed =
        metadata?.documentName ??
        metadata?.DocumentName ??
        fallbackDocumentName;
    }

    return documentNameDisplayed;
  };


  const getValidationRules = () => {
    return {
      hasValidCaseData: {
        required: true,
        validator: (value) => value === true, // Ensures if the CASE NUMBER is valid
      },
      hasValidDateData: {
        required: true,
        validator: (value, values) => {
          // If View All Documents is checked, date validation is not required
          if (values.viewAllDocuments) {
            return true;
          }
          return value === true; // Ensures if the DATE DATA is valid
        },
      },
      importStartDateTxt: {
        required: true,
        validator: (value, values) => {
          // Skip validation if View All Documents is checked
          if (values.viewAllDocuments) return true;
          if (!value || !values.importEndDateTxt) return true; // Skip validation if either date is missing
          return new Date(value) <= new Date(values.importEndDateTxt); // Check if startDate <= endDate
        },
      },
      importEndDateTxt: {
        required: true,
        validator: (value, values) => {
          // Skip validation if View All Documents is checked
          if (values.viewAllDocuments) return true;
          if (!value || !values.importStartDateTxt) return true; // Skip validation if either date is missing
          return new Date(value) >= new Date(values.importStartDateTxt); // Check if endDate >= startDate
        },
      },
      indexStartDateTxt: {
        required: true,
        validator: (value, values) => {
          // Skip validation if View All Documents is checked
          if (values.viewAllDocuments) return true;
          if (!value || !values.indexEndDateTxt) return true; // Skip validation if either date is missing
          return new Date(value) <= new Date(values.indexEndDateTxt); // Check if startDate <= endDate
        },
      },
      indexEndDateTxt: {
        required: true,
        validator: (value, values) => {
          // Skip validation if View All Documents is checked
          if (values.viewAllDocuments) return true;
          if (!value || !values.indexStartDateTxt) return true; // Skip validation if either date is missing
          return new Date(value) >= new Date(values.indexStartDateTxt); // Check if endDate >= startDate
        },
      },
    };
  };

  // Debounced validation using the centralized validateForm
  const debouncedValidation = useCallback(
    DebounceForm((values) => {
      try {
        const rules = getValidationRules();

        const validationResults = ValidateRequiredFieldsInForm(values, rules);
        const isValid = validationResults.isFormValid;

        setIsSearchEnabled(isValid);
      }
      catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "debouncedValidation", {});
      }
    }, 300),
    []
  );

  // Handle input changes dynamically
  const handleInputChange = async (e) => {
    try {
      const { name, value } = e.target;
      setSearchFormData({
        ...searchFormData,
        [name]: value
      });
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleInputChange: " + e.target.name);
    }
  };

  // Validate date - not empty and valid format
  const validateDate = (dateString) => {
    let hasDate = true;
    let validDate = true;
    let validYear = true;
    let validYearMessage = "";

    if (!dateString) {
      hasDate = false;
    }

    // Check if the date is valid
    const dateObj = new Date(dateString);
    if (isNaN(dateObj.getTime())) {
      validDate = false;
    }

    const enteredYear = dateObj.getFullYear();
    const currentYear = new Date().getFullYear();
    if (enteredYear < 2000 || enteredYear > currentYear) {
      validYear = false;
      validYearMessage = "Year must be entered between 2000 and " + currentYear;
    }

    return { hasDateValue: hasDate, validDateValue: validDate, validYearValue: validYear, validYearMessage: validYearMessage };
  };

  const validateImportStartDate = (startDate, endDate) => {
    let hasValidData = false;
    const { hasDateValue, validDateValue, validYearValue, validYearMessage } = validateDate(startDate);

    if (!hasDateValue) {
      setImportStartDateValidationMessage('Start date is required. Please enter a valid date and search again');
    }
    else if (!validDateValue) {
      setImportStartDateValidationMessage('Please enter a valid date and search again');
    }
    else if (!validYearValue) {
      setImportStartDateValidationMessage(validYearMessage);
    }
    else if (startDate && endDate && startDate > endDate) {
      setImportStartDateValidationMessage('Start date must be on or before end date');
    }
    else {
      hasValidData = true;
      setImportStartDateValidationMessage('');
    }

    return hasValidData;
  };

  const validateImportEndDate = (startDate, endDate) => {
    let hasValidData = false;
    const { hasDateValue, validDateValue, validYearValue, validYearMessage } = validateDate(endDate);

    if (!hasDateValue) {
      setImportEndDateValidationMessage('End date is required. Please enter a valid date and search again');
    }
    else if (!validDateValue) {
      setImportEndDateValidationMessage('Please enter a valid date and search again');
    }
    else if (!validYearValue) {
      setImportEndDateValidationMessage(validYearMessage);
    }
    else if (endDate && startDate && endDate < startDate) {
      setImportEndDateValidationMessage('End date must be on or after start date');
    }
    else {
      hasValidData = true;
      setImportEndDateValidationMessage('');
    }

    return hasValidData;
  };

  // Handle input changes dynamically
  const handleImportStartDateChange = async (e) => {
    try {
      const { name, value } = e.target;

      const validStartDate = validateImportStartDate(value, searchFormData.importEndDateTxt); 
      const validEndDate = validateImportEndDate(value, searchFormData.importEndDateTxt); 
      
      const updatedSearchFormData = {
        ...searchFormData,
        [name]: value,
        hasValidDateData: validStartDate === true && validEndDate === true,
      };
      setSearchFormData(updatedSearchFormData);

      // Validate the data entered in the form
      debouncedValidation(updatedSearchFormData);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleImportStartDateChange");
    }
  };

  // Handle input changes dynamically
  const handleImportEndDateChange = async (e) => {
    try {
      const { name, value } = e.target;

      const validStartDate = validateImportStartDate(searchFormData.importStartDateTxt, value); 
      const validEndDate = validateImportEndDate(searchFormData.importStartDateTxt, value); 
      
      const updatedSearchFormData = {
        ...searchFormData,
        [name]: value,
        hasValidDateData: validStartDate === true && validEndDate === true,
      };
      setSearchFormData(updatedSearchFormData);  

      // Validate the data entered in the form
      debouncedValidation(updatedSearchFormData);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleImportEndDateChange");
    }
  };

  const validateIndexStartDate = (startDate, endDate) => {
    let hasValidData = false;
    const { hasDateValue, validDateValue, validYearValue, validYearMessage } = validateDate(startDate);

    if (!hasDateValue) {
      setIndexStartDateValidationMessage('Start date is required. Please enter a valid date and search again');
    }
    else if (!validDateValue) {
      setIndexStartDateValidationMessage('Please enter a valid date and search again');
    }
    else if (!validYearValue) {
      setIndexStartDateValidationMessage(validYearMessage);
    }
    else if (startDate && endDate && startDate > endDate) {
      setIndexStartDateValidationMessage('Start date must be on or before end date');
    } 
    else {
      hasValidData = true;
      setIndexStartDateValidationMessage('');
    }

    return hasValidData;
  };

  const validateIndexEndDate = (startDate, endDate) => {
    let hasValidData = false;
    const { hasDateValue, validDateValue, validYearValue, validYearMessage } = validateDate(endDate);

    if (!hasDateValue) {
      setIndexEndDateValidationMessage('End date is required. Please enter a valid date and search again');
    }
    else if (!validDateValue) {
      setIndexEndDateValidationMessage('Please enter a valid date and search again');
    }
    else if (!validYearValue) {
      setIndexEndDateValidationMessage(validYearMessage);
    }
    else if (endDate && startDate && endDate < startDate) {
      setIndexEndDateValidationMessage('End date must be on or after start date');
    }
    else {
      hasValidData = true;
      setIndexEndDateValidationMessage('');
    }

    return hasValidData;
  };

  // Handle input changes dynamically
  const handleIndexStartDateChange = async (e) => {
    try {
      const { name, value } = e.target;

      const validStartDate = validateIndexStartDate(value, searchFormData.indexEndDateTxt);
      const validEndDate = validateIndexEndDate(value, searchFormData.indexEndDateTxt);

      const updatedSearchFormData = {
        ...searchFormData,
        [name]: value,
        hasValidDateData: validStartDate === true && validEndDate === true,
      };
      setSearchFormData(updatedSearchFormData);

      // Validate the data entered in the form
      debouncedValidation(updatedSearchFormData);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleIndexStartDateChange");
    }
  };

  // Handle input changes dynamically
  const handleIndexEndDateChange = async (e) => {
    try {
      const { name, value } = e.target;

      const validStartDate = validateIndexStartDate(searchFormData.indexStartDateTxt, value);
      const validEndDate = validateIndexEndDate(searchFormData.indexStartDateTxt, value);

      const updatedSearchFormData = {
        ...searchFormData,
        [name]: value,
        hasValidDateData: validStartDate === true && validEndDate === true,
      };
      setSearchFormData(updatedSearchFormData);

      // Validate the data entered in the form
      debouncedValidation(updatedSearchFormData);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleIndexEndDateChange");
    }
  };

  const validateDateOnClear = (fieldName) => {
    let validStartDate = true, validEndDate = true;
    switch (fieldName) {
      case "importStartDateTxt":
        validStartDate = validateImportStartDate("", searchFormData.importEndDateTxt);
        validEndDate = validateImportEndDate("", searchFormData.importEndDateTxt);
        break;

      case "importEndDateTxt":
        validStartDate = validateImportStartDate(searchFormData.importStartDateTxt, "");
        validEndDate = validateImportEndDate(searchFormData.importStartDateTxt, "");
        break;

      case "indexStartDateTxt":
        validStartDate = validateIndexStartDate("", searchFormData.indexEndDateTxt);
        validEndDate = validateIndexEndDate("", searchFormData.indexEndDateTxt);
        break;

      case "indexEndDateTxt":
        validStartDate = validateIndexStartDate(searchFormData.indexStartDateTxt, "");
        validEndDate = validateIndexEndDate(searchFormData.indexStartDateTxt, "");
        break;
    }

    return validStartDate === true && validEndDate === true;
  };

  const handleDateFieldClear = async (fieldName) => {
    try {

      if (inputDateRefs.current[fieldName]) {
        inputDateRefs.current[fieldName].value = ""; // Explicitly clear the Date DOM value
      }

      const validDate = validateDateOnClear(fieldName);

      // Update input value    
      const updatedFormValues = { ...searchFormData, [fieldName]: "", hasValidDateData: validDate };
      setSearchFormData(updatedFormValues);

      debouncedValidation(updatedFormValues);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDateFieldClear: " + fieldName);
    }
  };

  // Function to handle clear of case search value
  const handleCaseClear = async () => {
    setIsPageLoading(true);
    try {
      await simulateAsyncDelay();

      // Update input value and reset View All Documents    
      const updatedFormValues = { 
        ...searchFormData, 
        ['caseSearch']: "", 
        hasValidCaseData: true,
        viewAllDocuments: false
      };
      
      setViewAllDocumentsEnabled(false);
      if (caseNumberRef.current) {
        caseNumberRef.current.setValidationMessage("");
      }
      
      // Reset to default date range when case is cleared
      await resetToDefaultDateRange(updatedFormValues);
      
      await clearFormContents(false);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleCaseClear");
    }
    finally { setIsPageLoading(false); }
  };

  const changeCaseNumberIconsDisable = async (iconsEnabledValue) => {
    try {
      const updatedCaseNumberIconsEnabled = {
        ...caseNumberIconsDisabled,
        search: iconsEnabledValue.search,
        copy: iconsEnabledValue.copy,
        clear: iconsEnabledValue.clear,
      };
      UtilityLibrary.updateArrayStateValues(setCaseNumberIconsDisabled, updatedCaseNumberIconsEnabled);
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "changeCaseNumberIconsDisable", {});
    }
  };

  const checkCaseNumberRegEx = (caseNumber) => {// RC removed async as its not needed
    try {
      let isValidFormat = true;
      const caseNumberRegexValue = new RegExp(caseNumberRegex.caseRegexValue || "");

      // Only validate if we have a case number
      if (caseNumber !== "") {
        // First check database regex if available
        if (caseNumberRegex.caseRegexValue !== "" && !caseNumberRegexValue.test(caseNumber)) {
          caseNumberRef.current.setValidationMessage(caseNumberRegex.caseRegexMessage);
          // await changeCaseNumberIconsDisable({ search: true, copy: false, clear: false });
          isValidFormat = false;
        } else {
          const loginUserInfo = sessionService.getUser();
          const loginStateID = loginUserInfo ? loginUserInfo.stateID : -123456;
          
          // For Colorado (stateID 180), enforce 11 digits + 1 letter rule explicitly
          if (loginStateID === 180) {
            const coloradoPattern = /^\d{11}[A-Za-z]$/;
            if (!coloradoPattern.test(caseNumber)) {
              if (caseNumberRef.current) {
                caseNumberRef.current.setValidationMessage("Case number must be 11 digits followed by 1 letter.");
              }
              // await changeCaseNumberIconsDisable({ search: true, copy: false, clear: false });
              isValidFormat = false;
            }
          }
          // For Louisiana (stateID 120), enforce all numeric digits no more than 9 digits rule
          else if (loginStateID === 120) { 
            const louisianaPattern = /^[1-9]\d{0,8}$/;
            if (!louisianaPattern.test(caseNumber)) {
              if (caseNumberRef.current) {
                caseNumberRef.current.setValidationMessage("Case number must be all numeric digits, no more than 9 digits, no leading zeroes.");
              }
              // await changeCaseNumberIconsDisable({ search: true, copy: false, clear: false });
              isValidFormat = false;
            }
          }
          // For Kansas (stateID 4), enforce all numeric digits no more than 10 digits rule
          else if (loginStateID === 4) { 
            const kansasPattern = /^[1-9]\d{0,9}$/; 
            
            if (!kansasPattern.test(caseNumber)) {
              if (caseNumberRef.current) {
                caseNumberRef.current.setValidationMessage("Case number must be all numeric digits, no more than 10 digits, no leading zeroes.");
              }
              //await changeCaseNumberIconsDisable({ search: true, copy: false, clear: false });

              isValidFormat = false;
            }
          }
          // For Mississippi (stateID 30), enforce 9 digits followed by 1 letter rule
          else if (loginStateID === 30) { 
            const mississippiPattern = /^\d{9}[A-Za-z]$/; 
            if (!mississippiPattern.test(caseNumber)) {
              if (caseNumberRef.current) {
                caseNumberRef.current.setValidationMessage("Case number must be 9 digits followed by 1 letter.");
              }
              // await changeCaseNumberIconsDisable({ search: true, copy: false, clear: false });

              isValidFormat = false;
            }
          }
          // For Nebraska (stateID 230), enforce must begin with CA or CC and consist of 13 total digits
          else if (loginStateID === 230) { 
            const nebraskaPattern = /^(CA|CC)\d{11}$/; 
            if (!nebraskaPattern.test(caseNumber)) {
              caseNumberRef.current.setValidationMessage("Case number must begin with CA or CC and consist of 13 total digits.");
              // await changeCaseNumberIconsDisable({ search: true, copy: false, clear: false });
              isValidFormat = false;
            }
          }
          // For North Carolina (stateID 200), enforce all numeric, less than 10 digits, no leading zero
          else if (loginStateID === 200) { 
            const northCarolinaPattern = /^[1-9]\d{0,8}$/; 
            if (!northCarolinaPattern.test(caseNumber)) {
              caseNumberRef.current.setValidationMessage("Case number must be all numeric, less than 10 digits, no leading zeroes.");
              // await changeCaseNumberIconsDisable({ search: true, copy: false, clear: false });
              isValidFormat = false;
            }
          }
          // For Virginia (stateID 160), enforce all numeric, less than 10 digits, no leading zero
          else if (loginStateID === 160) { 
            const virginiaPattern = /^[1-9]\d{0,8}$/; 
            if (!virginiaPattern.test(caseNumber)) {
              caseNumberRef.current.setValidationMessage("Case number must be all numeric, less than 10 digits, no leading zeroes.");
              // await changeCaseNumberIconsDisable({ search: true, copy: false, clear: false });
              isValidFormat = false;
            }
          }
          // For Wyoming (stateID 140), enforce all numeric, no leading zero, less than 9 digits
          else if (loginStateID === 140) { 
            const wyomingPattern = /^[1-9]\d{0,7}$/; 
            if (!wyomingPattern.test(caseNumber)) {
              caseNumberRef.current.setValidationMessage("Case number must be all numeric, no more than 8 digits, no leading zeroes.");
              // await changeCaseNumberIconsDisable({ search: true, copy: false, clear: false });
              isValidFormat = false;
            }
          }
          // For ZZState (stateID 1000), enforce all numeric, no more than 10 digits
          else if (loginStateID === 1000) { 
            const zzStatePattern = /^\d{1,10}$/; 
            if (!zzStatePattern.test(caseNumber)) {
              caseNumberRef.current.setValidationMessage("Case number must be all numeric, no more than 10 digits.");
              // await changeCaseNumberIconsDisable({ search: true, copy: false, clear: false });
              isValidFormat = false;
            }
          }
        }
      }

      if (isValidFormat && caseNumber.trim() !== "") {
        if (caseNumberRef.current) {
          caseNumberRef.current.setValidationMessage("");
        }
        //await changeCaseNumberIconsDisable({ search: false, copy: false, clear: false });

      }

      // Do NOT automatically enable View All Documents checkbox here
      // It will be handled by the debounced logic in handleCaseChange to prevent enabling while typing

      return isValidFormat;
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "checkCaseNumberRegEx", {});
    }
  };

  const handleCaseChange = async (e) => {
    try {
      // RC do not make any async calls before case number 
      // state update to ensure the case number cursor stays 
      // in place while editing
      //const { value } = e.target;
      const valueText = e.target.value;
      const loginState = SessionManager.GetValueFromSession(SessionManager.LoginStateKey);

      // Always disable the checkbox while typing to prevent Issue 2
      setViewAllDocumentsEnabled(false);

      const isValidFormat = checkCaseNumberRegEx(valueText);

      // If case number is invalid or empty, reset View All Documents checkbox
      let updatedFormValues = { ...searchFormData, ['caseSearch']: valueText, hasValidCaseData: isValidFormat };
      
      if (!isValidFormat || valueText.trim() === "") {
        updatedFormValues.viewAllDocuments = false;
        // Reset to default Index Start Date when View All Documents is disabled
        if (searchFormData.viewAllDocuments) {
          await resetToDefaultDateRange(updatedFormValues);
          return;
        }
      }

      setSearchFormData(updatedFormValues);
      debouncedValidation(updatedFormValues);

      // Use a debounced approach to enable the checkbox after user stops typing
      if (valueText.trim() !== "") {
        setTimeout(async () => {
          // Re-validate the case number to ensure it meets state-specific requirements
          if (caseNumberRef.current && caseNumberRef.current.getTextValue() === valueText) {
            const finalValidation = await checkCaseNumberRegEx(valueText);
            if (finalValidation && valueText.trim() !== "") {
              setViewAllDocumentsEnabled(true);
            } else {
              setViewAllDocumentsEnabled(false);
            }
          }
        }, 250);
      }
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleCaseChange");
    }
  };

  const handleViewAllDocumentsChange = async (e) => {
    try {
      const isChecked = e.target.checked;
      
      if (isChecked) {
        // When View All Documents is selected
        const updatedFormValues = {
          ...searchFormData,
          viewAllDocuments: true,
          hasValidDateData: true
        };
        setSearchFormData(updatedFormValues);
        setSelectedRadioOption(""); // Clear radio button selection
        formFieldsEnableLogic(dispatch, null, { viewAllDocuments: true });
        debouncedValidation(updatedFormValues);
      } else {
        // When View All Documents is unchecked, reset to default date range
        await resetToDefaultDateRange({ ...searchFormData, viewAllDocuments: false });
      }
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleViewAllDocumentsChange");
    }
  };

  const resetToDefaultDateRange = async (baseFormData) => {
    try {
      const currentDate = UtilityLibrary.formatDate(new Date().toISOString(), "YYYY-MM-DD");
      const date = new Date(currentDate);
      date.setDate(date.getDate() - 30); // Subtract 30 days
      const startDate = date.toISOString().split("T")[0]; // Format as YYYY-MM-DD

      setSelectedRadioOption("indexDateSelectOption");
      const updatedFormValues = {
        ...baseFormData,
        indexStartDateTxt: startDate,
        indexEndDateTxt: currentDate,
        importStartDateTxt: "",
        importEndDateTxt: "",
        hasValidDateData: true,
      };
      setSearchFormData(updatedFormValues);
      
      // Clear DOM values for import date fields
      if (inputDateRefs.current['importStartDateTxt']) {
        inputDateRefs.current['importStartDateTxt'].value = "";
      }
      if (inputDateRefs.current['importEndDateTxt']) {
        inputDateRefs.current['importEndDateTxt'].value = "";
      }

      // Enable Index Date fields and disable Import Date fields
      formFieldsEnableLogic(dispatch, FormFieldEnableType.IndexDateSelect.ID);
      debouncedValidation(updatedFormValues);
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "resetToDefaultDateRange", {});
    }
  };


  /* 
  * Authorization code starts here
  * The permission values for fields are received from Web API
  * The received data from Web API response is processed and stored in a state variable "formFieldAccess"
  */
  useEffect(() => {
    const fetchFormFieldPermissions = async () => {
      try {
        //TODO: Pass variables from session to the below URL
        const loginUserInfo = sessionService.getUser();
        const loginStateID = loginUserInfo ? loginUserInfo.stateID : -123456;
        const params = {
          clientID: loginStateID,
          formID: 20      // To-do: Modify Code - Hard-coded value of FormID: 20
        }
        const controlSecurityListApiData = await ApiManager.FetchControlsPermissions(params);
        const actualPermissionsForFields = DeterminePermissions(controlSecurityListApiData);
        setFormFieldAccess({ ...defaultPermissionsForFields, ...actualPermissionsForFields });
      } catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "fetchFormFieldPermissions", {});
      }
    };

    try {
      fetchFormFieldPermissions();
    }
    catch (error) {
      LoggerUtility.ManageErrorLogging(error, errorFormName, "fetchFormFieldPermissions - page load");
    }
  }, []);

  /**************************************************************************** */

  const loadDefaultDate = async (recentFormData) => {
    try {
      const currentDate = UtilityLibrary.formatDate(new Date().toISOString(), "YYYY-MM-DD");
      const date = new Date(currentDate);
      date.setDate(date.getDate() - 30); // Subtract 30 days
      const startDate = date.toISOString().split("T")[0]; // Format as YYYY-MM-DD

      setSelectedRadioOption("indexDateSelectOption");
      const updatedFormValues = {
        ...recentFormData,
        indexStartDateTxt: startDate,
        indexEndDateTxt: currentDate,
        importStartDateTxt: "",
        importEndDateTxt: "",
        hasValidDateData: true,
      };
      setSearchFormData(updatedFormValues);
      // Validate the data entered in the form
      debouncedValidation(updatedFormValues);
      formFieldsEnableLogic(dispatch, FormFieldEnableType.IndexDateSelect.ID);

      if (inputDateRefs.current['importStartDateTxt']) {
        inputDateRefs.current['importStartDateTxt'].value = ""; // Explicitly clear the Date DOM value
      }
      if (inputDateRefs.current['importEndDateTxt']) {
        inputDateRefs.current['importEndDateTxt'].value = ""; // Explicitly clear the Date DOM value
      }

    } catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "loadDefaultDate", {});
    }
  };

  // Default Date set for Index Date on Page Load
   useEffect(() => {
    try {
      loadDefaultDate(searchFormData);
    }
    catch (error) {
      LoggerUtility.ManageErrorLogging(error, errorFormName, "loadDefaultDate - page load");
    }
  }, []); 


  /**************************************************************************** */

  const loadAllDocumentTypes = async (docGroupList) => {
    const allDocumentTypes = docGroupList
      .filter(item => item.documentGroupTypeID !== 0)
      .flatMap(group => group.documentTypes || []);
    setDocumentTypes(allDocumentTypes.sort((a, b) => a.documentTypeName.localeCompare(b.documentTypeName)));
  };

  //Document Group dropdown API code
  useEffect(() => {
    const fetchDocGroups = async () => {
      try {
        const loginUserInfo = sessionService.getUser();
        const loginStateID = loginUserInfo ? loginUserInfo.stateID : -123456;
        const params = {
          clientID: loginStateID,
          documentTypeActive: ClientType.ActiveStatus.Obsolete};
        const docGroupApiData = await ApiManager.GetDocGroupsFromApi(params);
        /* const withCaseCondition = (item) => item.caseNoCaseFlag === 2 || item.caseNoCaseFlag === 3; */
        const withCaseCondition = (item) => item.caseNoCaseFlag >= 0;
        const withCaseGroupData = UtilityLibrary.filterArrayByCondition(docGroupApiData[0], withCaseCondition);
        // Sort document groups alphabetically by name
        const sortedDocGroups = withCaseGroupData.sort((a, b) => a.documentGroupTypeName.localeCompare(b.documentGroupTypeName));
        const updatedDocGroup = [{ documentGroupTypeID: 0, documentGroupTypeName: "All", documentTypes: [{}] }, ...sortedDocGroups];
        //const response = await axios.get('https://localhost:7183/api/docgroup/getdocgrouplist/1');
        if (docGroupApiData.length > 0) {
          //const updatedDocGroup = [{ documentGroupTypeID: 0, documentGroupTypeName: "All", documentTypes: [{}] }, ...docGroupApiData[0]];
          setSelectedDocGroup(0);
          setDocGroupList(updatedDocGroup);
          loadAllDocumentTypes(updatedDocGroup);
        }
        else {
          setDocGroupList([]);
          setDocumentTypes([]);
        }

      } catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "fetchDocGroups", {});
      }
    };

    try {
      fetchDocGroups();
    }
    catch (error) {
      LoggerUtility.ManageErrorLogging(error, errorFormName, "fetchDocGroups - page load");
    }
  }, []);

  //Document Source dropdown API code
  useEffect(() => {
    const fetchDocSources = async () => {
      try {
        //TODO: Pass variables from session to the below URL
        const params = {
          activeDocumentSourceTypeOnly: 0,
          documentSourceTypeID: 0
        }
        const docSourceListApiData = await ApiManager.GetDocSourceFromApi(params);
        //const response = await axios.get('https://localhost:7183/api/DocumentSource/GetDocumentSourceList/0/0');
        setDocSourelists(docSourceListApiData);

      } catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "fetchDocSources", {});
      }
    };

    try {
      fetchDocSources();
    }
    catch (error) {
      LoggerUtility.ManageErrorLogging(error, errorFormName, "fetchDocSources - page load");
    }
  }, []);

  //Documnet Source dropdown loading code end.

  //Index By dropdown loading code start.  
  useEffect(() => {
    const fetchIndexBy = async () => {
      try {
        //TODO: Pass variables from session to the below URL
        const params = {
          masterServerDBSchema
        }
        const indexByListApiData = await ApiManager.GetIndexedByUserFromApi(params);
        // const response = await axios.get('https://localhost:7183/api/IndexUser/GetIndexList/YTracG2_Master.dbo');
        setIndexBylists(indexByListApiData);
      } catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "fetchIndexBy", {});
      }
    };

    try {
      fetchIndexBy();
    }
    catch (error) {
      LoggerUtility.ManageErrorLogging(error, errorFormName, "fetchIndexBy - page load");
    }
  }, []);

  //Index By dropdown loading code end.



  const handleDocGroupChange = async (event, newValue, reason) => {
    try {
      let value = "";
      if (reason !== "clear") {
        value = newValue.documentGroupTypeID;
      }

      const groupID = value;
      setSelectedDocGroup(groupID);
      setSelectedDocType("");

      if (groupID === 0 || groupID === null) {
        const allDocumentTypes = docGroupList
          .filter(item => item.documentGroupTypeID !== 0)
          .flatMap(group => group.documentTypes || []);
        setDocumentTypes(allDocumentTypes.sort((a, b) => a.documentTypeName.localeCompare(b.documentTypeName)));
      }
      else {
        // Find the selected group and set its document types
        const selectedGroup = docGroupList.find(group => group.documentGroupTypeID === groupID);
        setDocumentTypes(selectedGroup ? selectedGroup.documentTypes.sort((a, b) => a.documentTypeName.localeCompare(b.documentTypeName)) : []);
      }
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDocGroupChange");
    }
  };

  const handleDocType = async (event, newValue, reason) => {
    try {
      let value = "";
      if (reason !== "clear") {
        value = newValue.documentTypeID;
      }

      setSelectedDocType(value);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDocType");
    }
  };

  const handleDocSource = async (event, newValue, reason) => {
    try {
      let value = "";
      if (reason !== "clear") {
        value = newValue.documentSourceTypeID;
      }

      setSelectedDocSource(value);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDocSource");
    }
  };

  const handleIndexBy = async (event, newValue, reason) => {
    try {
      let value = "";
      if (reason !== "clear") {
        value = newValue.userID;
      }

      setSelectedIndexBy(value);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleIndexBy");
    }
  };

  /**************************************************************************** */


  const openManageKeywords = async () => {
    setIsPageLoading(true);
    try {
      await simulateAsyncDelay();

      const { isLocked } = await checkAndLockBatchDocumentBeforeEdit("openManageKeywords");
      if (isLocked) {
        return;
      }

      setPageTitleCurrent(manageKeywordsPageTitle);
      setShowManageKeywords(true);

      await clearCaseInfoForm();
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "openManageKeywords");
    }
    finally {
      /* if (manageKeywordRef.current) {
        manageKeywordRef.current.scrollIntoView({ behavior: "smooth" });
      } */

      setIsPageLoading(false);
    }
  };

  const closeManageKeywords = () => {
    try {
      setPageTitleCurrent(documentSearchPageTitle);
      setShowManageKeywords(false);
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "closeManageKeywords", {});
    }
  };

  const getDataFromManageKeyword = async (data) => {
    try {
      if (data) {
        if (!data.showManageKeyword) {
          closeManageKeywords();
          setEnableManageKeywords(false);
          setEnableShowDocument(false);
          await clearCaseInfoForm();
        }
        if (data.showMessage) {
          await handleCaseSearch();
          // Set flag to focus Case Search field after notification dialog closes
          setShouldFocusCaseSearch(true);
          handleNotificationDialog(data.dialogContent, true);
        }
      }
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "getDataFromManageKeyword");
    }
  };

  const simulateAsyncDelay = async () => {
    await new Promise((resolve) => setTimeout(resolve, 500));
  };

  const onDocumentSearch = async () => {
    try {
      await clearCaseInfoForm();
      const searchDocsApiData = await getSearchDataFromApi();
      if (!searchDocsApiData || searchDocsApiData.length === 0) {
        await showNoDocumentsFound();
        return;
      }
      setDocResults(searchDocsApiData);
      // Reset to the first page after search
      setPaginationModel((prev) => ({ ...prev, page: 0 }));
      await clearSearchGridFilters();
      setEnableShowDocument(false);
      setEnableManageKeywords(false);
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "onDocumentSearch", {});
    }
  };

  const showNoDocumentsFound = async () => {
    setDocResults([]);
    setHasSearchResults(false);
    setInitialSearch(true);
    setEnableShowDocument(false);
    setEnableManageKeywords(false);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
    await clearSearchGridFilters();
    await clearCaseInfoForm();
  };

  const getCaseInfoFromApiByID = async (caseID) => {
    try {
      const params = {
        caseNumber: caseID,
        apiMainframeUrl: configLibrary.apiMainframeUrl,
        masterServerDBSchema // Added to params.
      };
      // DocumentSearch right pane always uses database only (not state systems)
      const caseApiData = await ApiManager.GetCaseDataFromDbByID(params);
      return caseApiData;
    }
    catch (error) {
      console.error('❌ getCaseInfoFromApiByID error:', error);
      throw LoggerUtility.ProcessErrorData(error, "getCaseInfoFromApiByID", {});
    }
  };

  const onCaseNumberSearch = async () => {
    try {
      // For Document Search (Re-Index), case number is just search criteria for documents
      // Don't validate case existence, just proceed with document search
      if (viewOnly) {
        // For Re-Index mode, case number is only search criteria - don't validate case
        await onDocumentSearch();
      } else {
        // For regular Document Search mode, validate case exists
        const isValidCaseFormat = await checkCaseNumberRegEx(searchFormData.caseSearch);
        if (isValidCaseFormat) {
          const caseApiData = await getCaseInfoFromApiByID(searchFormData.caseSearch);
          const caseInfoData = caseApiData.caseInfo;
          if (caseInfoData && caseInfoData.length > 0) {
            await onDocumentSearch();
          }
          else {
            await showNoDocumentsFound();
          }
        }
        else {
          const dialogContent = {
            ...EnumUtility.NotificationAlerts.CaseNumberFormatInvalid,
            dynamicMessageContent: [searchFormData.caseSearch, caseNumberRegex.caseRegexMessage],
          };
          handleNotificationDialog(dialogContent);
        }
      }
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "onCaseNumberSearch", {});
    }
  };

  // Function to handle Case search
  const handleCaseSearch = async (event) => {
    setIsPageLoading(true);
    try {
      await simulateAsyncDelay();
      await onCaseNumberSearch();
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleCaseSearch");
    }
    finally { setIsPageLoading(false); }
  };

  // Function to handle Document search
  const handleDocumentSearch = async (event) => {
    setIsPageLoading(true);
    try {
      await simulateAsyncDelay();
      // For Re-Index mode, case number is just search criteria - don't validate format
      if (viewOnly) {
        await onDocumentSearch();
      } else {
        // For regular Document Search mode, validate case number format
        const isValidCaseFormat = await checkCaseNumberRegEx(searchFormData.caseSearch);
        if (isValidCaseFormat) {
          await onDocumentSearch();
        }
        else {
          const dialogContent = {
            ...EnumUtility.NotificationAlerts.CaseNumberFormatInvalid,
            dynamicMessageContent: [searchFormData.caseSearch, caseNumberRegex.caseRegexMessage],
          };
          handleNotificationDialog(dialogContent);
        }
      }
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDocumentSearch");
    }
    finally { setIsPageLoading(false); }
  };

  // Function to handle Cancel click and Redirects to the NewDocument component
  const handleCancelClick = async () => {
    try {
      setActivePage('newDocument');
      navigate('/newdocument'); // Redirects to the NewDocument component
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleCancelClick");
    }
    finally { }
  };

  const clearCaseInfoForm = async () => {
    try {
      setCurrentCaseFormData([]);
      setCaseInfoFormVisibility(false);
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "clearCaseInfoForm", {});
    }
  };

  const clearFormContents = async (preserveCaseNumber = false) => {
    try {
      
      //caseNumberRef.current.clearAllText();
      setSelectedDocGroup(0);
      setSelectedDocType("");
      setSelectedDocSource("");
      setSelectedIndexBy("");
      setViewAllDocumentsEnabled(false); // Reset View All Documents checkbox state

      setDocResults([]);
      setInitialSearch(false);
      setHasSearchResults(false);
      setEnableShowDocument(false);
      setEnableManageKeywords(false);

      if (caseNumberRef.current) {
        caseNumberRef.current.setValidationMessage("");
      }
      setImportStartDateValidationMessage('');
      setImportEndDateValidationMessage('');
      setIndexStartDateValidationMessage('');
      setIndexEndDateValidationMessage('');

      if (inputDateRefs.current['importStartDateTxt']) {
        inputDateRefs.current['importStartDateTxt'].value = ""; // Explicitly clear the Date DOM value
      }
      if (inputDateRefs.current['importEndDateTxt']) {
        inputDateRefs.current['importEndDateTxt'].value = ""; // Explicitly clear the Date DOM value
      }

      const updatedFormValues = { 
        ...searchFormData, 
        ...initialFormData,
        caseSearch: preserveCaseNumber ? searchFormData.caseSearch : ""
      };
      UtilityLibrary.updateArrayStateValues(setSearchFormData, updatedFormValues);
      await loadDefaultDate(updatedFormValues);
      // //caseNumberRef.current.clearAllText();
      await loadAllDocumentTypes(docGroupList);
      await clearCaseInfoForm();

    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "clearFormContents", {});
    }
  };

  useEffect(() => {
    // 🔍 FIXED: Add safety check before calling clearFormContents
    if (caseNumberRef.current) {
      clearFormContents();
    }
    closeManageKeywords();
  }, [mainTitle]);

  // Function to handle clear of form contents
  const handleClearClick = async () => {
    try {
      await clearFormContents();
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleClearClick");
    }
    finally { }
  };

  const handleClearBatchClick = async (e) => {
    const updatedSearchFormData = {
      ...searchFormData,
      batchNumberTxt: ""
    };
    setSearchFormData(updatedSearchFormData);
  };


  const getSearchDataFromApi = async () => {
    try {
      const loginUserInfo = sessionService.getUser();
      const loginStateID = loginUserInfo ? loginUserInfo.stateID : -123456;
      setInitialSearch(true);
      let setStartDate = null;
      let setEndDate = null;
      let isImportDateSearch = true;
      
      // If View All Documents is checked, don't use date filters
      if (searchFormData.viewAllDocuments) {
        setStartDate = "1900-01-01";
        const currentDate = new Date().toISOString().split("T")[0]; 
        setEndDate = currentDate;   
        isImportDateSearch = false; 
      } else if (selectedRadioOption === "importDateSelectOption") {
        setStartDate = searchFormData.importStartDateTxt;
        setEndDate = searchFormData.importEndDateTxt;
      } else if (selectedRadioOption === "indexDateSelectOption") {
        setStartDate = searchFormData.indexStartDateTxt;
        setEndDate = searchFormData.indexEndDateTxt;
        isImportDateSearch = false;
      }

      let docGroupID = selectedDocGroup;
      if (selectedDocGroup === 0) {
        if (selectedDocType !== "") {
          docGroupID = UtilityLibrary.getParentIdByChildId(docGroupList, 'documentGroupTypeID', 'documentTypes', 'documentTypeID', selectedDocType);
        }
      }
      docGroupID = docGroupID > 0 ? docGroupID : -999;

      const params = {
        startDate: setStartDate,
        endDate: setEndDate,
        caseNumber: searchFormData.caseSearch !== '' ? searchFormData.caseSearch : -999,
        batchNumber: searchFormData.batchNumberTxt !== "" ? searchFormData.batchNumberTxt : -999,
        indexedByUserLoginID: selectedIndexBy !== "" ? selectedIndexBy : -999,
        documentGroupTypeId: docGroupID,
        documentTypeID: selectedDocType !== "" ? selectedDocType : -999,
        masterServerDBSchema,
        ytracSiteID: loginStateID, // loginStateID - TO-DO - CODE_MODIFY: Modify the SiteID - Should pass StateID
        documentSourceTypeID: selectedDocSource !== "" ? selectedDocSource : -999,
        searchByScanDate: isImportDateSearch,
        systemTimeZoneName: timeZone 
      };

      //const docsSearchAPIurl = `${ApiManager.DocumentSearchApiUrl}${params.startDate}/${params.endDate}/${params.caseNumber}/${params.batchNumber}/${params.userindexedByUserLoginID}/${params.documentTypeID}/${params.masterServerDBSchema}/${params.ytracSiteID}/${params.documentSourceTypeID}/${params.searchByScanDate}`;

      const docSearchApiData = await ApiManager.GetDocSearchFromApiByID(params);
      //const docSearchApiData = await ApiManager.GetDataFromAPI(docsSearchAPIurl);
      if (docSearchApiData && docSearchApiData.length > 0) {

        const docResultsCapacity = siteSettingDetail.DocumentResultsCapacity || 100;
        const totalResultsCount = docSearchApiData[0].resultSearchCount;
        if(totalResultsCount > docResultsCapacity) {
          const dialogContent = {
            ...EnumUtility.NotificationAlerts.DocumentSearchExcessiveResults,
            dynamicMessageContent: [totalResultsCount, docResultsCapacity],
          };
          handleNotificationDialog(dialogContent, false); // Do not auto-close, require user to click OK
        }

        setHasSearchResults(true);
        return docSearchApiData;
      }
      else {
        setHasSearchResults(false);
        return [];
      }
    }
    catch (error) {
      setHasSearchResults(false);
      throw LoggerUtility.ProcessErrorData(error, "getSearchDataFromApi", {});
    }
  };


  const onUpdateCaseInfoToForm = async (caseApiData) => {
    try {
      // Check if data is directly in response (not nested under caseInfo)
      if (caseApiData && caseApiData.caseNumber) {
        setCaseInfoFormVisibility(true);
        setCurrentCaseFormData(caseApiData);
      } else {
        // Original logic - check for nested caseInfo object (not array)
        const caseInfoData = caseApiData.caseInfo;
        if (caseInfoData && typeof caseInfoData === 'object' && caseInfoData.caseNumber) {
          setCaseInfoFormVisibility(true);
          setCurrentCaseFormData(caseInfoData);
        }
        else {
          setCaseInfoFormVisibility(true);
          setCurrentCaseFormData({});
        }
      }
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "onLoadCaseInfoToForm", {});
    }
  };

  const onLoadCaseInfoToForm = async (caseNumber) => {
    try {
      const caseApiData = await getCaseInfoFromApiByID(caseNumber);
      await onUpdateCaseInfoToForm(caseApiData);
    }
    catch (error) {
      console.error('❌ onLoadCaseInfoToForm error:', error);
      throw LoggerUtility.ProcessErrorData(error, "onLoadCaseInfoToForm", {});
    }
  };

  const onSelectDocsFromGrid = async (params) => {
    try {
      const {documentUNCPath, batchDocumentID, batchName, batchID, caseNumber, documentName } = params.row;
      console.log("Seected DOC",params.row)

      const { isLocked } = await checkAndLockBatchDocumentBeforeEdit("onSelectDocsFromGrid", batchDocumentID);
      if (isLocked) {
        setEnableManageKeywords(false);
        setEnableShowDocument(false);
        return;
      }

      if (caseNumber) {
        await onLoadCaseInfoToForm(caseNumber);
      } else {
        await clearCaseInfoForm();
      }

      const docsUncAPI = ApiManager.DocumentUncApiUrl;
      const { hasError, isFileExists, fileUrl, errorList } = await DocumentUtility.GetFileUncPath(docsUncAPI, documentUNCPath);
      //const fileUrl = await DocumentUtility.GetFileUncPath(docsUncAPI, documentUNCPath);

     if (!hasError) {
        const documentNameDisplayed = await getDocumentNameDisplayed(params.row);
        const selectedDocument = {
          ...params.row,
          DocumentName_Displayed: documentNameDisplayed
        };

        setUncDocumentUrl(fileUrl);
        setSelectedDoc(selectedDocument);
        setCaseBatchDocumentID(batchDocumentID);
        setSelectedDocData(selectedDocument);
        setEnableManageKeywords(true);
        setEnableShowDocument(true);
      }
     else {
        const currentDate = UtilityLibrary.formatDate(new Date(), customDateFormat);
        const loginUserInfo = sessionService.getUser();
        const { stateName, firstName, lastName} = loginUserInfo
        
        const dialogMessage = `Document Preview Failed. Please contact Helpdesk.
          Exception = 'Failed to retrieve document from the path
          Date/Time of Error = ${currentDate}
          State = ${stateName}
          Page = ${viewOnly? 'Document Search': 'Re-Index'}
          User = ${firstName} ${lastName}
          Region =  ${configLibrary.hostedEnvironment}            
          CaseNumber = ${caseNumber}
          Batch = ${batchName}
          Document ID = ${batchDocumentID}`;
        handleNotificationDialog({ NotificationType: "error", Message: dialogMessage })
      }

      /* if (isFileExists) {
        setEnableShowDocument(true);
      }
      else {
        setEnableShowDocument(false);
        handleNotificationDialog(EnumUtility.NotificationAlerts.DocumentNotFound);
      } */

    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "onSelectDocsFromGrid");
    }
  };

  const handleGridFilterChange = async (newFilterModel) => {
    try {
      setGridFilterModel(newFilterModel);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridFilterChange");
    }
  };

  const clearSearchGridFilters = async () => {
    try {
      setGridFilterModel({ items: [] });
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "handleNotificationDialog", {});
    }
  };

  const handleGridClearFilters = async () => {
    try {
      await clearSearchGridFilters();
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridClearFilters");
    }
  };

//Remove it if not needed
  // const onSelectDocsFromGrid03 = async (params) => {
  //   const { completeDocumentPath } = params.row;
  //   const { batchDocumentID } = params.row;

  //   let tempDocUrl = "";
  //   if (testDocLoad) { setDocumentUrl('document-003.pdf'); setUncDocumentUrl('document-003.pdf'); tempDocUrl = 'document-0013.pdf'; } else { setDocumentUrl('document-004.pdf'); setUncDocumentUrl('document-004.pdf'); tempDocUrl = 'document-004.pdf'; }

  //   setEnableShowDocument(true);
  //   //setDocumentUrl(completeDocumentPath);
  //   setCaseBatchDocumentID(batchDocumentID);
  //   setSelectedDoc(batchDocumentID);

  //   setTestDocLoad(testDocLoad ? false : true);
  //   setEnableManageKeywords(true);

  //   const checkFilePath = await UtilityLibrary.checkFileExistsInPath(tempDocUrl);
  //   if (!checkFilePath) {
  //     handleNotificationDialog(EnumUtility.NotificationAlerts.DocumentNotFound);
  //   }
  // };

  // Handler to reset trigger after displaying list of cases in manage keywords
  const resetShowCasesByBatchDoc = () => {
    setShowCasesByBatchDoc(false);    // Reset trigger after search is processed
  };

  // Event handler for radio button change
  const handleRadioChange = async (event) => {
    try {
      // Don't allow radio button changes if View All Documents is checked
      if (searchFormData.viewAllDocuments) {
        return;
      }

      const selectedOption = event.target.value;
      setSelectedRadioOption(selectedOption);

      const currentDate = UtilityLibrary.formatDate(new Date().toISOString(), "YYYY-MM-DD");

      const date = new Date(currentDate);
      date.setDate(date.getDate() - 30); // Subtract 30 days
      const startDate = date.toISOString().split("T")[0]; // Format as YYYY-MM-DD

      if (selectedOption === "importDateSelectOption") {
        if (inputDateRefs.current['indexStartDateTxt']) {
          inputDateRefs.current['indexStartDateTxt'].value = ""; // Explicitly clear the Date DOM value
        }
        if (inputDateRefs.current['indexEndDateTxt']) {
          inputDateRefs.current['indexEndDateTxt'].value = ""; // Explicitly clear the Date DOM value
        }
        const updatedFormValues = {
          ...searchFormData,
          importStartDateTxt: startDate,
          importEndDateTxt: currentDate,
          indexStartDateTxt: "",
          indexEndDateTxt: "",
          hasValidDateData: true,
        };
        setSearchFormData(updatedFormValues);
        // Validate the data entered in the form
        debouncedValidation(updatedFormValues);
        formFieldsEnableLogic(dispatch, FormFieldEnableType.ImportDateSelect.ID);
      } else if (selectedOption === "indexDateSelectOption") {
        if (inputDateRefs.current['importStartDateTxt']) {
          inputDateRefs.current['importStartDateTxt'].value = ""; // Explicitly clear the Date DOM value
        }
        if (inputDateRefs.current['importEndDateTxt']) {
          inputDateRefs.current['importEndDateTxt'].value = ""; // Explicitly clear the Date DOM value
        }
        const updatedFormValues = {
          ...searchFormData,
          importStartDateTxt: "",
          importEndDateTxt: "",
          indexStartDateTxt: startDate,
          indexEndDateTxt: currentDate,
          hasValidDateData: true,
        };
        setSearchFormData(updatedFormValues);
        // Validate the data entered in the form
        debouncedValidation(updatedFormValues);
        formFieldsEnableLogic(dispatch, FormFieldEnableType.IndexDateSelect.ID);
      }

      setImportStartDateValidationMessage('');
      setImportEndDateValidationMessage('');
      setIndexStartDateValidationMessage('');
      setIndexEndDateValidationMessage('');

    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleRadioChange: " + event.target.name);
    }
  };

  const handlePaginationModelChange = (newPaginationModel) => {
    // Only update the state if the new model is different from the current one

    // Reset the page to 0 if the pageSize changes
    if (newPaginationModel.pageSize !== paginationModel.pageSize) {
      setPaginationModel({ ...newPaginationModel, page: 0 });
    } else {
      // Otherwise, update the pagination model as usual
      setPaginationModel(newPaginationModel);
    }

  };


  const handleNotificationDialog = (dialogContent, timerAutoClose = false, timeToClose = 5000, position = "center") => {
    try {
      setNotificationDialogContent(dialogContent);    
      setTimerNotificationDialogClose(timeToClose);
      setTimerAutoCloseNotificationDialog(timerAutoClose);
      setNotificationDialogPosition(position);
      handleOpenNotificationDialog();
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "handleNotificationDialog", {});
    }
  };

  const handleOpenNotificationDialog = () => {
    try {
      setNotificationDialogOpen(true);
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "handleOpenNotificationDialog", {});
    }
  };

  const handleCloseNotificationDialog = useCallback(async () => {
    try {
      setNotificationDialogOpen(false);
      
      // Set focus to Case Search field if a save operation from ManageKeywords just completed
      if (shouldFocusCaseSearch) {
        setShouldFocusCaseSearch(false);
        setTimeout(() => {
          if (caseNumberRef.current) {
            caseNumberRef.current.focus();
          }
        }, 100);
      }
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleCloseNotificationDialog");
    }
  }, [shouldFocusCaseSearch]);


  const formContentRef = [useRef(null)];
  const [columnSizeCSS, setColumnSizeCSS] = useState('col-yt-2');
  const [actionButtonCSS, setActionButtonCSS] = useState('col-yt-2');

  useEffect(() => {
    try {
      // Initialize resize listener for all refs
      const columnSize = UtilityLibrary.initializeResizeListener([formContentRef[0], formContentRef[0]], [setColumnSizeCSS, setActionButtonCSS], [500, 500]);
      return columnSize; // Cleanup on unmount
    }
    catch (error) {
      LoggerUtility.ManageErrorLogging(error, errorFormName, "Column Size - page load");
    }
  }, []);



  //=======================================================================
  // Confirmation Dialog - Begin
  //=======================================================================

  const handleConfirmationDialog = (dialogContent) => {
    setConfirmationDialogContent(dialogContent);
    handleOpenConfirmDialog();
  };

  const handleOpenConfirmDialog = () => {
    setConfirmDialogOpen(true);
  };

  const handleCloseConfirmDialog = () => {
    setSplitArgs(null);
    setPendingEditorCloseAction(null);
    setConfirmDialogOpen(false);
  };

  const handleDocumentEditorCloseRequest = ({ hasSelectedPages, closeEditor }) => {
    if (!hasSelectedPages) {
      closeEditor();
      return false;
    }

    setPendingEditorCloseAction(() => closeEditor);
    handleConfirmationDialog(EnumUtility.ConfirmDialogType.CloseDocumentEditor);
    return false;
  };

  const handleDialogConfirmAction = async (dialogContentID) => {
    try {
      switch (dialogContentID) {

        case EnumUtility.ConfirmDialogType.SplitDocument.ID:
          handleConfirmSplit();
          break;

        case EnumUtility.ConfirmDialogType.SplitAllDocument.ID:
          handleConfirmSplitAll();
          break;

        case EnumUtility.ConfirmDialogType.DeleteDocumentPages.ID:
          handleConfirmDelete();
          break;

        case EnumUtility.ConfirmDialogType.CloseDocumentEditor.ID:
          if (pendingEditorCloseAction) {
            pendingEditorCloseAction();
            setPendingEditorCloseAction(null);
          }
          break;

        default:
          break;
      }

      setConfirmDialogOpen(false);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDialogConfirmAction");
    }
  };

  //=======================================================================
  // Confirmation Dialog - End
  //=======================================================================

  //=======================================================================
  // Delete Document page Process - Begin
  //=======================================================================

  // Handler for the Delete button press
  const handleDeleteButtonPress = async (event, { setOperations, getSelectedPageIndexes }) => {
    try {
      const { isLocked } = await checkAndLockBatchDocumentBeforeEdit("handleDeleteButtonPress");
      if (isLocked) {
        return;
      }

      const selectedPageIndexes = getSelectedPageIndexes();
      let docSplitData = batchDataService.getSplitDocumentData();

      if (selectedPageIndexes.length > 0 && selectedPageIndexes.length < docSplitData.batchInstance.totalPageCount) {
        // const { isLocked } = await checkBatchLockBeforeDocumentAction("handleDeleteButtonPress");
        // if (isLocked) {
        //   return;
        // } -- Commenting this out. As per MQ, batch lock checking on re-index will be replaced by document lock status checking - SFS

        // Store the arguments for later use
        setSplitArgs({ setOperations, getSelectedPageIndexes });
        // Show the confirmation dialog
        handleConfirmationDialog(EnumUtility.ConfirmDialogType.DeleteDocumentPages);
      }
      else {
        handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSplitNotAvailable); //Prevent split button from being clicked if no pages are selected
      };
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDeleteButtonPress");
    }
  };

  // Handler for confirming the split
  const handleConfirmDelete = async () => {
    try {
      if (splitArgs) {
        //const buttonType = "Delete";
        const buttonOperationType = EnumUtility.DocumentViewerOperationType.DeleteButton.ID;
        const { setOperations, getSelectedPageIndexes } = splitArgs;
        // Perform the split operation using the stored arguments
        await performSplitOperation(setOperations, getSelectedPageIndexes, buttonOperationType);
      }
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleConfirmDelete");
    }
  };

  //=======================================================================
  // Delete Document page Process - End
  //=======================================================================


  //=======================================================================
  // Split Document Process - Begin
  //=======================================================================

  // Handler for the split button press
  const handleSplitButtonPress = async (event, { setOperations, getSelectedPageIndexes }) => {
    try {
      const { isLocked } = await checkAndLockBatchDocumentBeforeEdit("handleSplitButtonPress");
      if (isLocked) {
        return;
      }

      const selectedPageIndexes = getSelectedPageIndexes();
      let docSplitData = batchDataService.getSplitDocumentData();

      if (selectedPageIndexes.length > 0) {
        // const { isLocked } = await checkBatchLockBeforeDocumentAction("handleSplitButtonPress");
        // if (isLocked) {
        //   return;
        // } -- Commenting this out. As per MQ, batch lock checking on re-index will be replaced by document lock status checking - SFS

        // Store the arguments for later use
        setSplitArgs({ setOperations, getSelectedPageIndexes });
        // Show the confirmation dialog
        handleConfirmationDialog(EnumUtility.ConfirmDialogType.SplitDocument);
      }
      else {
        handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSplitNotAvailable); //Prevent split button from being clicked if no pages are selected
      };
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSplitButtonPress");
    }
  };

  // Handler for confirming the split
  const handleConfirmSplit = async () => {
    try {
      if (splitArgs) {
        //const buttonType = "Split";
        const buttonOperationType = EnumUtility.DocumentViewerOperationType.SplitButton.ID;
        const { setOperations, getSelectedPageIndexes } = splitArgs;
        // Perform the split operation using the stored arguments
        await performSplitOperation(setOperations, getSelectedPageIndexes, buttonOperationType);
      }
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleConfirmSplit");
    }
  };

  // Function to perform the split operation
  const performSplitOperation = async (setOperations, getSelectedPageIndexes, buttonOperationType) => {
    try {
      let docSplitData = batchDataService.getSplitDocumentData();
      const totalpageIndexes = UtilityLibrary.itemsArray(docSplitData.batchInstance.totalPageCount);
      const selectedPageIndexes = getSelectedPageIndexes();
      const selectedPageIndexesForProcessing =
        buttonOperationType === EnumUtility.DocumentViewerOperationType.SplitButton.ID
          && selectedPageIndexes.length === totalpageIndexes.length
          ? selectedPageIndexes.slice(1)
          : selectedPageIndexes;
      const remainingPageIndexes = UtilityLibrary.differenceArray(totalpageIndexes, selectedPageIndexesForProcessing);

      if (selectedPageIndexesForProcessing.length > 0) { //TODO Plan A. Prevent split button from being active if no pages are selected
        selectedPageIndexesForProcessing?.length && setOperations((operations) => {

          if (docSplitData.batchInstance) {
            docSplitData.batchInstance.exportPDFWithOperations([
              ...operations,
              { type: "removePages", pageIndexes: remainingPageIndexes },
            ]).then(async (buffer) => {
              //this is only necessary if you want to download the file to the current device
              docSplitData.splitOffBuffer = buffer;
              docSplitData.splitOffDocument_Blob = new Blob([buffer], { type: "application/pdf" });

              //console.log("splitOffDocument_Blob size:", splitOffDocument_Blob.size); // Log the size of the blob


            });
          }
          if (docSplitData.batchInstance) {
            docSplitData.batchInstance.exportPDFWithOperations([
              ...operations,
              { type: "removePages", pageIndexes: selectedPageIndexesForProcessing },
            ]).then(async (buffer) => {
              //this is only necessary if you want to download the file to the current device
              docSplitData.currentDocument_Blob = new Blob([buffer], { type: "application/pdf" });
              //console.log("currentDocument_Blob size:", currentDocument_Blob.size); // Log the size of the blob

              const customOptions = { origin: "DocumentSearch" };
              let pageCount = remainingPageIndexes.length;

              await batchDataService.UpdateBatchDocument(caseBatchDocumentID, pageCount, 'TBD', customOptions);  // Update Current Document

              if (buttonOperationType === EnumUtility.DocumentViewerOperationType.SplitButton.ID) {  // If the split button was pressed create batch and document. If type = "Delete" then do nothing.
                await batchDataService.InsertBatch();

                docSplitData = batchDataService.getSplitDocumentData();
                pageCount = selectedPageIndexesForProcessing.length;

                await batchDataService.InsertBatchDocument(caseBatchDocumentID, pageCount, docSplitData.newBatchID, customOptions);  // Create the new split off Document in current Batch
              }
              docSplitData = batchDataService.getSplitDocumentData();

              // basePath = \\yt_dev_file.ywcss.local\YWDMS_Dev$\ZZ\
              // batch Path = 2025\02\22\500920
              // fileName = 20250222042516.pdf

              //const siteSettingDetail = SessionManager.GetValueFromSession(SessionManager.SiteSettingsDetailsKey);
              docSplitData.basePath = siteSettingDetail.DocumentPath;
              //docSplitData.basePath = SessionManager.GetValueFromSession(SessionManager.DocumentPathKey);


              docSplitData.documentUNCPath = docSplitData.basePath + docSplitData.currentDocumentbatchPath + "\\" + docSplitData.currentDocumentFileName;
              await DocumentUtility.SaveFileToPhysicalPath(docSplitData.currentDocument_Blob, docSplitData.documentUNCPath);
              //saveFile(docSplitData.currentDocument_Blob, docSplitData.currentDocumentFileName, docSplitData.documentUNCPath, docSplitData.buffer);  //Save the modified current document to the server.

              if (buttonOperationType === EnumUtility.DocumentViewerOperationType.SplitButton.ID) {  // If the split button was pressed save the document. If type = "Delete" then don't save the document.
                docSplitData.documentUNCPath = docSplitData.basePath + docSplitData.splitOffDocumentbatchPath + "\\" + docSplitData.splitDocumentFileName;
                await DocumentUtility.SaveFileToPhysicalPath(docSplitData.splitOffDocument_Blob, docSplitData.documentUNCPath);
                //saveFile(splitOffDocument_Blob, splitDocumentFileName, documentUNCPath, splitOffBuffer);  //Save the split document to the server.
              }

              if (pdfViewerRef.current) {
                await pdfViewerRef.current.handleDocumentExport(buffer, docSplitData.batchInstance);
              }

              //await handleDocumentExport(buffer, docSplitData.batchInstance);
              if (buttonOperationType === EnumUtility.DocumentViewerOperationType.SplitButton.ID) {  // If the split button was pressed, notify user about new batch.
                handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSearchSplitSuccess, true);
              } else if (buttonOperationType === EnumUtility.DocumentViewerOperationType.DeleteButton.ID) {  // If the Delete button was pressed, notify user about deleted pages.
                handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSearchDeleteSuccess, true);
              }

            });
          }
          return operations;
        });
      } else {
        handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSplitNotAvailable); //Prevent split button from being clicked if no pages are selected
      };
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "performSplitOperation", {});
    }
  };

  // Handler for the split all button press
  const handleSplitAllButtonPress = async (event, { setOperations, getSelectedPageIndexes }) => {
    try {
      const docSplitData = batchDataService.getSplitDocumentData();
      const totalPageCount = docSplitData.batchInstance?.totalPageCount || 0;

      if (totalPageCount <= 1) {
        handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSplitAllNotAvailable);
        return;
      }

      const { isLocked } = await checkAndLockBatchDocumentBeforeEdit("handleSplitAllButtonPress");
      if (isLocked) {
        return;
      }

      // Store the arguments for later use
      setSplitArgs({ setOperations, getSelectedPageIndexes });
      // Show the confirmation dialog
      handleConfirmationDialog(EnumUtility.ConfirmDialogType.SplitAllDocument);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSplitAllButtonPress");
    }
  };

  // Handler for confirming the split all
  const handleConfirmSplitAll = async () => {
    try {
      if (splitArgs) {
        const { setOperations } = splitArgs;
        // Perform the split all operation using the stored arguments
        await performSplitAllOperation(setOperations);
      }
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleConfirmSplitAll");
    }
  };

  // Function to perform the split all operation. Every page except the first is split off into
  // its own single-page document/batch, in page order, directly behind the original document.
  const performSplitAllOperation = async (setOperations) => {
    try {
      let docSplitData = batchDataService.getSplitDocumentData();
      const totalPageIndexes = UtilityLibrary.itemsArray(docSplitData.batchInstance?.totalPageCount || 0);
      const pagesToSplitOff = totalPageIndexes.slice(1); // Page 0 remains with the original document

      if (pagesToSplitOff.length === 0) {
        handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSplitAllNotAvailable);
        return;
      }

      await new Promise((resolve, reject) => {
        setOperations((operations) => {
          (async () => {
            try {
              if (!docSplitData.batchInstance) {
                resolve();
                return;
              }

              // Export a single-page buffer for every page that will become its own document.
              const splitOffBuffers = [];
              for (const pageIndex of pagesToSplitOff) {
                const pagesToRemove = totalPageIndexes.filter((index) => index !== pageIndex);
                const pageBuffer = await docSplitData.batchInstance.exportPDFWithOperations([
                  ...operations,
                  { type: "removePages", pageIndexes: pagesToRemove },
                ]);
                splitOffBuffers.push(pageBuffer);
              }

              // Export the buffer for the original document, now containing only its first page.
              const currentBuffer = await docSplitData.batchInstance.exportPDFWithOperations([
                ...operations,
                { type: "removePages", pageIndexes: pagesToSplitOff },
              ]);
              docSplitData.currentDocument_Blob = new Blob([currentBuffer], { type: "application/pdf" });

              const customOptions = { origin: "DocumentSearch" };

              await batchDataService.UpdateBatchDocument(caseBatchDocumentID, 1, 'TBD', customOptions);  // Update Current Document to a single page

              docSplitData = batchDataService.getSplitDocumentData();
              docSplitData.basePath = siteSettingDetail.DocumentPath;

              docSplitData.documentUNCPath = docSplitData.basePath + docSplitData.currentDocumentbatchPath + "\\" + docSplitData.currentDocumentFileName;
              await DocumentUtility.SaveFileToPhysicalPath(docSplitData.currentDocument_Blob, docSplitData.documentUNCPath);

              // Create each split off page as its own document in its own new batch, in page order, directly behind the original.
              for (let index = 0; index < splitOffBuffers.length; index++) {
                const splitOffBlob = new Blob([splitOffBuffers[index]], { type: "application/pdf" });
                docSplitData.splitOffDocument_Blob = splitOffBlob;

                await batchDataService.InsertBatch();

                docSplitData = batchDataService.getSplitDocumentData();

                await batchDataService.InsertBatchDocument(
                  caseBatchDocumentID,
                  1,
                  docSplitData.newBatchID,
                  { ...customOptions, uniqueSuffix: index + 1 }
                );

                docSplitData = batchDataService.getSplitDocumentData();
                docSplitData.basePath = siteSettingDetail.DocumentPath;
                docSplitData.documentUNCPath = docSplitData.basePath + docSplitData.splitOffDocumentbatchPath + "\\" + docSplitData.splitDocumentFileName;
                await DocumentUtility.SaveFileToPhysicalPath(splitOffBlob, docSplitData.documentUNCPath);
              }

              if (pdfViewerRef.current) {
                await pdfViewerRef.current.handleDocumentExport(currentBuffer, docSplitData.batchInstance);
              }

              handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSearchSplitAllSuccess, true);

              resolve();
            }
            catch (innerError) {
              reject(innerError);
            }
          })();

          return operations;
        });
      });
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "performSplitAllOperation");
    }
  };


  //=======================================================================
  // Split Document Process - End
  //=======================================================================


  //=======================================================================
  // ROTATE - Save Document Process - Begin
  //=======================================================================

  // Handler for the save rotate button press
  const handleSaveRotateButtonPress = async (event, { setOperations, getSelectedPageIndexes }) => {
    try {
      const { isLocked } = await checkAndLockBatchDocumentBeforeEdit("handleSaveRotateButtonPress");
      if (isLocked) {
        return;
      }

      // const { isLocked } = await checkBatchLockBeforeDocumentAction("handleSaveRotateButtonPress");
      // if (isLocked) {
      //   return;
      // } -- Commenting this out. As per MQ, batch lock checking on re-index will be replaced by document lock status checking - SFS

      // const { documentBuffer, batchInstance } = await BusinessUtility.PerformSaveAfterRotateOperation(getBatchDocument.BatchDocumentID, setOperations, getSelectedPageIndexes);
      const rotateResult = await BusinessUtility.PerformSaveAfterRotateOperation(pdfViewerRef, caseBatchDocumentID, setOperations, getSelectedPageIndexes);
      if (!rotateResult?.hasOperations) {
        return;
      }

      handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentRotateSuccess, true);
    }
    catch (error) {
      await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSaveRotateButtonPress");
    }
  };

//=======================================================================
// ROTATE - Save Document Process - End
//=======================================================================


    //=======================================================================
    // Save As Process - Begin
    //=======================================================================

    // Handler for the save as button press
    const handleSaveAsButtonPress = async () => {

      const docSplitData = batchDataService.getSplitDocumentData();

      // Export the document as a Blob
      const buffer = await docSplitData.batchInstance.exportPDF();
      const blob = new Blob([buffer], { type: "application/pdf" });

      const paramsBatchDoc = {
          batchDocumentID: selectedDoc.batchDocumentID, //getBatchDocument.BatchDocumentID,
      };
      const batchDocApiData = await ApiManager.GetBatchDocumentByIDFromApi(paramsBatchDoc);

      const docLocation = await BusinessUtility.replaceExtensionWithPdf(batchDocApiData.documentLocation);
      if (!docLocation || docLocation.trim().length === 0) {
          docLocation = 'document.pdf' 
      }

      try {
      const handle = await window.showSaveFilePicker({
          suggestedName: docLocation, // Default file name
          types: [
          {
              description: 'PDF Files',
              accept: { 'application/pdf': ['.pdf'] },
          },
          ],
      });

      // Create a writable stream and write the Blob to it
      const writable = await handle.createWritable();
      await writable.write(blob);
      await writable.close();

      console.log("Document saved successfully.");
      } catch (error) {
      console.error("Error saving document:", error);
      }
  };

  //=======================================================================
  // Save As Process - End
  //=======================================================================


  const handleCopyPathButtonPress = async () => {
    try{
      const loginUserInfo = sessionService.getUser();
      const { stateID, siteID, legacyUserID: userID } = loginUserInfo || {};
      // Get temp file set det
      const setDetailIDs = [ClientType.SettingsDetail.DMS_Scanning__Copy_Link_Temp_Path,
      ClientType.SettingsDetail.UI_Miscellaneous__Success_Notification_TIMER]
      const params = {
        settingsDetailIDList: setDetailIDs.join(","),
        yTracSiteID: stateID
      }
      const settingDetails = await ApiManager.GetSettingsDetailValuesFromApi(params); 
      const messageContentData = await SharedService.getMessageContent(ClientType.MessageContent.N_UI7057_Document_Path_Copied);
      const timerValue = (settingDetails?.settingDetailsApiData.find(
        value => parseInt(value.settingsDetailID) === ClientType.SettingsDetail.UI_Miscellaneous__Success_Notification_TIMER)?.settingsDetailValue || 3) * 1000;
      await SharedService.handleCopyPathButtonPress(selectedDoc, uncDocumentUrl, settingDetails, { stateID, siteID, userID }, masterServerDBSchema);
       // Display notification dialog
      handleNotificationDialog({ NotificationType: "success", Message: messageContentData?.messageText}, true,
        timerValue, "top-right"
      )
    }
    catch (err) {
      handleNotificationDialog({ NotificationType: "error", Message: 'Error occured while coping the file path' }, true,
        3000, "top-right"
      );
    }   
  } 
  const handlePDFViewerError = async(errorMessage) => {
    const loginUserInfo = sessionService.getUser();
    const { stateName, firstName, lastName} = loginUserInfo
    const { caseNumber, batchDocumentID, batchName } = selectedDocData
    const currentDate = UtilityLibrary.formatDate(new Date(), customDateFormat);
    
    const dialogMessage = `Document Preview Failed. Please contact Helpdesk.
      Exception = ${errorMessage}s
      Date/Time of Error = ${currentDate}
      State = ${stateName}
      Page = ${viewOnly? 'View-Document(s)': 'Re-Index'}
      User = ${firstName} ${lastName}
      Region =  ${configLibrary.hostedEnvironment}            
      CaseNumber = ${caseNumber}
      Batch = ${batchName}
      Document ID = ${batchDocumentID}`;
       
    handleNotificationDialog({ NotificationType: "error", Message: dialogMessage })
  }


  const leftPaneContent = (
    <div className="content-main-container">
      <div className="pane-wrap-container">
        {!showManageKeywords &&
          <div className="pane-main-container-v01">
            {/* Header Section */}
            <header className="form-header">
              <div className="text-wrapper-header" style={{ padding: '5px 5px' }}>{formTitle}</div>
            </header>
            {/* Form Section */}
            <div className='form-content'>
              <div className='form-dynamic-content'>
                <form className="form-dynamic-grid">
                  {/* Field 1 */}
                  {!(formFieldAccess.caseNumberTxt?.hide ?? false) && (
                    <div className='form-row'>
                      <div className='form-group'>
                        <TextFieldWithIconButton
                          ref={caseNumberRef}
                          nameForField="caseNumberTxt"
                          onClearButtonClick={handleCaseClear}
                          onTextChange={handleCaseChange}
                          valueForField={searchFormData.caseSearch}
                          labelForField="Case Number"
                          iconsDisabled={caseNumberIconsDisabled}
                           iconsVisibility = {{search: false, copy: true, clear: true}}
                          iconsTooltipText={{ copy: 'Copy Case', clear: 'Clear Case' }}
                          isDisabled={!(formFieldAccess.caseNumberTxt?.write ?? true)}
                          disableKeyDown={true}
                        />
                      </div>
                      <div className='form-group'>
                        {!(formFieldAccess.viewAllDocumentsChk?.hide ?? false) && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                id="viewAllDocumentsChk"
                                name="viewAllDocumentsChk"
                                checked={searchFormData.viewAllDocuments}
                                onChange={handleViewAllDocumentsChange}
                                disabled={!viewAllDocumentsEnabled || !(formFieldAccess.viewAllDocumentsChk?.write ?? true)}
                                color="primary"
                              />
                            }
                            label="View All Documents"
                            sx={{ 
                              marginTop: 2,
                              color: (viewAllDocumentsEnabled && (formFieldAccess.viewAllDocumentsChk?.write ?? true)) ? 'inherit' : 'rgba(0, 0, 0, 0.38)'
                            }}
                          />
                        )}
                      </div>
                    </div>
                  )}

                  <div className='form-row'>
                    <div className='form-group'>
                      {!(formFieldAccess.docGroupSelect?.hide ?? false) && (
                        <FormControl fullWidth>
                          <Autocomplete
                            options={docGroupList}
                            getOptionLabel={(option) => option.documentGroupTypeName || ""}
                            isOptionEqualToValue={(option, value) => option.documentGroupTypeID === value?.documentGroupTypeID}

                            id="docGroupSelect"
                            name="docGroupSelect"
                            value={docGroupList.find((opt) => opt.documentGroupTypeID === selectedDocGroup) || null}
                            IconComponent={ArrowDropDown}
                            label="Document Group"
                            noOptionsText="Document Group not found"
                            displayEmpty

                            disabled={!(formFieldAccess.docGroupSelect?.write ?? true)}

                            onChange={(event, newValue, reason) => {
                              // Manually construct the target object for consistency
                              const modifiedEvent = {
                                target: {
                                  name: "docGroupSelect", // Define the name of the Autocomplete
                                  childName: "docTypeSelect" // Define the name of the child -- Document Type
                                },
                              };
                              handleDocGroupChange(modifiedEvent, newValue, reason);
                            }}

                            renderInput={(params) => (
                              <TextField {...params}
                                label="Document Group"
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true, // Always keeps the label shrunk
                                }}
                              />)}
                          >
                          </Autocomplete>
                        </FormControl>
                      )}
                    </div>
                    <div className='form-group'>
                      {!(formFieldAccess.docTypeSelect?.hide ?? false) && (
                        <FormControl fullWidth>
                          <Autocomplete
                            options={documentTypes}
                            getOptionLabel={(option) => option.documentTypeName || ""}
                            isOptionEqualToValue={(option, value) => option.documentTypeID === value?.documentTypeID}

                            id="docTypeSelect"
                            name="docTypeSelect"
                            value={documentTypes.find((opt) => opt.documentTypeID === selectedDocType) || null}
                            IconComponent={ArrowDropDown}
                            label="Document Type"
                            noOptionsText="Document Type not found"
                            displayEmpty

                            disabled={!(formFieldAccess.docTypeSelect?.write ?? true)}

                            onChange={(event, newValue, reason) => {
                              // Manually construct the target object for consistency
                              const modifiedEvent = {
                                target: {
                                  name: "docTypeSelect", // Define the name of the Autocomplete
                                  parentName: "docGroupSelect" // Define the name of the parent -- Document Group
                                },
                              };
                              handleDocType(modifiedEvent, newValue, reason);
                            }}

                            renderInput={(params) => (
                              <TextField {...params}
                                label="Document Type"
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true, // Always keeps the label shrunk
                                }}
                              />)}
                          >
                          </Autocomplete>
                        </FormControl>
                      )}
                    </div>
                  </div>

                  <div className='form-row'>
                    <div className='form-group'>
                      {!(formFieldAccess.documentSourceSelect?.hide ?? false) && (
                        <FormControl fullWidth>
                          <Autocomplete
                            options={docSourelists}
                            getOptionLabel={(option) => option.documentSourceTypeName || ""}
                            isOptionEqualToValue={(option, value) => option.documentSourceTypeID === value?.documentSourceTypeID}

                            disabled={!(formFieldAccess.documentSourceSelect?.write ?? true)}

                            id="documentSourceSelect"
                            name="documentSourceSelect"
                            value={docSourelists.find((opt) => opt.documentSourceTypeID === selectedDocSource) || null}
                            IconComponent={ArrowDropDown}
                            label="Document Source"
                            noOptionsText="Document Source not found"
                            displayEmpty

                            onChange={(event, newValue, reason) => {
                              // Manually construct the target object for consistency
                              const modifiedEvent = {
                                target: {
                                  name: "documentSourceSelect", // Define the name of the Autocomplete
                                },
                              };
                              handleDocSource(modifiedEvent, newValue, reason);
                            }}

                            renderInput={(params) => (
                              <TextField {...params}
                                label="Document Source"
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true, // Always keeps the label shrunk
                                }}
                              />)}
                          >
                          </Autocomplete>
                        </FormControl>
                      )}
                    </div>
                    <div className='form-group'>
                      {!(formFieldAccess.indexBySelect?.hide ?? false) && (
                        <FormControl fullWidth>
                          <Autocomplete
                            options={indexBylists}
                            getOptionLabel={(option) => option.displayName || ""}
                            isOptionEqualToValue={(option, value) => option.userID === value?.userID}

                            disabled={!(formFieldAccess.indexBySelect?.write ?? true)}

                            id="indexBySelect"
                            name="indexBySelect"
                            value={indexBylists.find((opt) => opt.userID === selectedIndexBy) || null}
                            IconComponent={ArrowDropDown}
                            label="Index By"
                            noOptionsText="Index By not found"
                            displayEmpty

                            onChange={(event, newValue, reason) => {
                              // Manually construct the target object for consistency
                              const modifiedEvent = {
                                target: {
                                  name: "indexBySelect", // Define the name of the Autocomplete
                                },
                              };
                              handleIndexBy(modifiedEvent, newValue, reason);
                            }}

                            renderInput={(params) => (
                              <TextField {...params}
                                label="Index By"
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true, // Always keeps the label shrunk
                                }}
                              />)}
                          >
                          </Autocomplete>
                        </FormControl>
                      )}
                    </div>
                  </div>
                  <div className='form-row'>
                    <div className='form-group'>
                      {!(formFieldAccess.indexStartDateTxt?.hide ?? false) && (
                        <div>
                          <div className="d-flex">
                            <input
                              type="radio"
                              value="indexDateSelectOption"
                              checked={selectedRadioOption === "indexDateSelectOption"}
                              onChange={handleRadioChange}
                              disabled={searchFormData.viewAllDocuments}
                              className='me-2'
                            />
                            <FormControl fullWidth>
                              <TextField label="Index Start Date" type="date" InputLabelProps={{ shrink: true }}
                                id="indexStartDateTxt"
                                name="indexStartDateTxt"
                                
                                inputRef={(el) => (inputDateRefs.current.indexStartDateTxt = el)}
                                value={searchFormData.indexStartDateTxt}
                                onChange={handleIndexStartDateChange}
                                disabled={!formState.indexStartDateSelect}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton onClick={() => handleDateFieldClear("indexStartDateTxt")} disabled={!formState.indexStartDateSelect}>
                                        <ClearIcon color={formState.indexStartDateSelect ? "ywButtonBlue" : "grey" } />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                sx={{
                                  '& input[type="date"]::-webkit-calendar-picker-indicator': {
                                    filter: 'invert(40%) sepia(24%) saturate(3168%) hue-rotate(207deg) brightness(102%) contrast(84%)',
                                    // or:
                                  },
                                }}
                              />
                            </FormControl>
                          </div>
                          {indexStartDateValidationMessage && (
                            <span style={{ color: "red", fontSize: "12px", marginTop: "5px", display: "block" }}>
                              {indexStartDateValidationMessage}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                    <div className='form-group'>
                      {!(formFieldAccess.indexEndDateTxt?.hide ?? false) && (
                        <div>
                          <FormControl fullWidth>
                            <TextField label="Index End Date" type="date" InputLabelProps={{ shrink: true }}
                              id="indexEndDateTxt"
                              name="indexEndDateTxt"
                              inputRef={(el) => (inputDateRefs.current.indexEndDateTxt = el)}
                              value={searchFormData.indexEndDateTxt}
                              disabled={!formState.indexEndDateSelect}
                              onChange={handleIndexEndDateChange}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton onClick={() => handleDateFieldClear("indexEndDateTxt")} disabled={!formState.indexEndDateSelect}>
                                      <ClearIcon color={formState.indexEndDateSelect ? "ywButtonBlue" : "grey" } />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                              sx={{
                                '& input[type="date"]::-webkit-calendar-picker-indicator': {
                                  filter: 'invert(40%) sepia(24%) saturate(3168%) hue-rotate(207deg) brightness(102%) contrast(84%)',
                                  // or:
                                },
                              }}
                            />
                          </FormControl>
                          {indexEndDateValidationMessage && (
                            <span style={{ color: "red", fontSize: "12px", marginTop: "5px", display: "block" }}>
                              {indexEndDateValidationMessage}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='form-row'>
                    <div className='form-group'>
                      {!(formFieldAccess.importStartDateTxt?.hide ?? false) && (
                        <div>
                          <div className="d-flex">
                            <input
                              type="radio"
                              value="importDateSelectOption"
                              checked={selectedRadioOption === "importDateSelectOption"}
                              onChange={handleRadioChange}
                              disabled={searchFormData.viewAllDocuments}
                              className='me-2'
                            />
                            <FormControl fullWidth>
                              <TextField label="Import Start Date" type="date" InputLabelProps={{ shrink: true }}
                                id="importStartDateTxt"
                                name="importStartDateTxt"
                                inputRef={(el) => (inputDateRefs.current.importStartDateTxt = el)}
                                value={searchFormData.importStartDateTxt}
                                onChange={handleImportStartDateChange}
                                disabled={!formState.importStartDateSelect}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton onClick={() => handleDateFieldClear("importStartDateTxt")} disabled={!formState.importStartDateSelect}>
                                        <ClearIcon color={formState.importStartDateSelect ? "ywButtonBlue" : "grey" } />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                sx={{
                                  '& input[type="date"]::-webkit-calendar-picker-indicator': {
                                    filter: 'invert(40%) sepia(24%) saturate(3168%) hue-rotate(207deg) brightness(102%) contrast(84%)',
                                    // or:
                                  },
                                }}
                              />
                            </FormControl>
                          </div>
                          {importStartDateValidationMessage && (
                            <span style={{ color: "red", fontSize: "12px", marginTop: "5px", display: "block" }}>
                              {importStartDateValidationMessage}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                    <div className='form-group'>
                      {!(formFieldAccess.importEndDateTxt?.hide ?? false) && (
                        <div>
                          <FormControl fullWidth>
                            <TextField label="Import End Date" type="date" InputLabelProps={{ shrink: true }}
                              id="importEndDateTxt"
                              name="importEndDateTxt"
                              inputRef={(el) => (inputDateRefs.current.importEndDateTxt = el)}
                              value={searchFormData.importEndDateTxt}
                              onChange={handleImportEndDateChange}
                              disabled={!formState.importEndDateSelect}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton onClick={() => handleDateFieldClear("importEndDateTxt")} disabled={!formState.importEndDateSelect}>
                                      <ClearIcon color={formState.importEndDateSelect ? "ywButtonBlue" : "grey" } />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                              sx={{
                                '& input[type="date"]::-webkit-calendar-picker-indicator': {
                                  filter: 'invert(40%) sepia(24%) saturate(3168%) hue-rotate(207deg) brightness(102%) contrast(84%)',
                                  // or:
                                },
                              }}
                            />
                          </FormControl>
                          {importEndDateValidationMessage && (
                            <span style={{ color: "red", fontSize: "12px", marginTop: "5px", display: "block" }}>
                              {importEndDateValidationMessage}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>                  
                </form>

                {/* DataGrid */}
                {!(formFieldAccess.documentsDgrd?.hide ?? false) && (
                  <div className="data-grid-container">
                    {/* DataGrid for Search Results */}
                    <div className="yt-button-container">
                      <div className="text-wrapper-header-2" style={{ paddingLeft: '10px' }}>Search Results</div>
                      <div className="document-grid-header">
                        {!(formFieldAccess.clearFiltersBtn?.hide ?? false) && (
                          <Button id="clearFiltersBtn" name="clearFiltersBtn" variant="text" color="ywTextBlue" className="clear-filters-btn" onClick={handleGridClearFilters} disabled={!(formFieldAccess.clearFiltersBtn?.write ?? true)}>CLEAR FILTERS</Button>
                        )}
                      </div>
                    </div>                    
                    <div style={{ marginTop: '2px', height: '100%', width: "100%" }}>
                      {hasSearchResults ?
                        <DataGridPremium
                          id="documentsDgrd"
                          name="documentsDgrd"
                          rows={resultsDocsWithIndex}
                          columns={documentGridColumns}
                          rowsPerPageOptions={[5, 10, 15, 20, 25]}
                          pagination
                          pageSizeOptions={[5, 10, 15, 20, 25]}
                          paginationModel={paginationModel} // Controlled pagination
                          onPaginationModelChange={setPaginationModel} // Handle page changes                    
                          getRowId={(row) => `${row.batchDocumentID}-${row.rowIndex}`}
                          onRowClick={onSelectDocsFromGrid}
                          filterModel={gridFilterModel}
                          onFilterModelChange={handleGridFilterChange}
                          disableSelectionOnClick
                          sx={{
                            "& .MuiDataGrid-row:hover": {
                              cursor: "pointer"
                            },
                            ".MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": {
                              "margin-top": "1em",
                              "margin-bottom": "1em"
                            },
                            "& .MuiDataGrid-virtualScroller": { overflowX: "auto", overflowY: "auto" }
                          }}
                        />
                        : initialSearch && (<div className="text-wrapper-subtitle">No document(s) found for the search criteria!</div>)
                      }
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* Footer Section */}
            <footer className="form-footer">
              <div className={`${actionButtonCSS === "col-yt-1" ? "col-yt-1" : "d-flex justify-content-between align-items-center mb-2 form-actions"}`}>
                <div className='leftDiv'>
                  {!viewOnly && (
                    !(formFieldAccess.cancelBtn?.hide ?? false) && (
                      <Button id="cancelBtn" name="cancelBtn" color="ywButtonWhite" variant='outlined' className='me-3' onClick={handleCancelClick} disabled={!(formFieldAccess.cancelBtn?.write ?? true)}>Cancel</Button>
                    )
                  )}
                  {!(formFieldAccess.clearBtn?.hide ?? false) && (
                    <Button id="clearBtn" name="clearBtn" color="ywButtonWhite" variant='outlined' className='me-3' onClick={handleClearClick} disabled={!(formFieldAccess.clearBtn?.write ?? true)}>Clear</Button>
                  )}
                </div>
                <div className='rightDiv'>
                  {!(formFieldAccess.searchBtn?.hide ?? false) && (
                    <Button id="searchBtn" name="searchBtn" variant='contained' color='ywButtonBlue' className='me-3' onClick={handleDocumentSearch} disabled={!isSearchEnabled}>Search</Button>
                  )}
                  {!viewOnly && (
                    !(formFieldAccess.manageKeywordsBtn?.hide ?? false) && (
                      <Button id="manageKeywordsBtn" name="manageKeywordsBtn" variant='contained' color='ywButtonBlue' className='me-3' onClick={openManageKeywords} disabled={!enableManageKeywords}>Manage Keywords</Button>
                    )
                  )}
                </div>
              </div>
            </footer>
          </div>
        }
        {showManageKeywords &&
          <div>
            <ManageKeywords
              caseBatchDocumentID={caseBatchDocumentID}
              showCasesByBatchDoc={showCasesByBatchDoc}
              resetExtCaseDetails={resetShowCasesByBatchDoc}
              showAlertMessage={showAlert}
              setter={getDataFromManageKeyword}
              manageKeywords={true} />
          </div>
        }
      </div>
    </div >
  );

  const rightPaneContent = (
    <div className="content-main-container">
      <div className="pane-wrap-container">
        <div className="pane-main-container">
          <div className="form-section docViewerForm" style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            {/* Sticky Case Information Section */}
            <div 
              style={{ 
                flexShrink: 0,
                position: 'sticky',
                top: 0,
                zIndex: 10,
                backgroundColor: 'white',
                padding: '4px', 
                width: '100%'
              }} 
              hidden={!caseInfoFormVisibility}
            >
              {/* Top Section (Yellow) */}
              <div className="form-caseInfo-container">
                {!(formFieldAccess.caseNumberLbl?.hide ?? false) && (
                  <div className="form-caseInfo-field">
                    <label className="text-wrapper-subtitle caseInfo-Title">Case ID:</label>
                    <label id="caseNumberLbl" name="caseNumberLbl" className="text-wrapper-subtitle caseInfo-Content">{currentCaseFormData.caseNumber || ''}</label>
                  </div>
                )}
                {!(formFieldAccess.cpNameLbl?.hide ?? false) && (
                  <div className="form-caseInfo-field">
                    <label className="text-wrapper-subtitle caseInfo-Title">CP:</label>
                    <label id="cpNameLbl" name="cpNameLbl" className="text-wrapper-subtitle caseInfo-Content">
                      {((currentCaseFormData.cpFirstName || '') + ' ' + (currentCaseFormData.cpLastName || '')).trim() || ''}
                    </label>
                  </div>
                )}
              </div>
              <div className="form-caseInfo-container">
                {!(formFieldAccess.cpNameLbl?.hide ?? false) && (
                  <div className="form-caseInfo-field">

                  </div>
                )}
                {!(formFieldAccess.ncpNameLbl?.hide ?? false) && (
                  <div className="form-caseInfo-field">
                    <label className="text-wrapper-subtitle caseInfo-Title">NCP:</label>
                    <label id="ncpNameLbl" name="ncpNameLbl" className="text-wrapper-subtitle caseInfo-Content">
                      {((currentCaseFormData.ncpFirstName || '') + ' ' + (currentCaseFormData.ncpLastName || '')).trim() || ''}
                    </label>
                  </div>
                )}
              </div>
              <div className='row' style={{ padding: "4px 25px" }}>
                <div className='col-12' style={{ padding: "2px", borderBottom: '2px solid grey' }}>
                </div>
              </div>
            </div>
            {(enableShowDocument && selectedDoc?.DocumentName_Displayed) && (
              <div style={{ padding: "5px 25px" }}>
                <label
                  id="documentNameLbl"
                  name="documentNameLbl"
                  className="text-wrapper-subtitle caseInfo-Title"
                  style={{ userSelect: 'text', cursor: 'text' }}
                >
                  {selectedDoc.DocumentName_Displayed}
                </label>
              </div>
            )}
            {/* Scrollable Content Area */}
            <div style={{ flex: 1, minHeight: 0 }}>
              <div style={{ height: '100%' }}>
                {(enableShowDocument && selectedDoc?.batchDocumentID && uncDocumentUrl !== "") && (
                  <div style={{ width: '100%', height: '100%' }}>
                    <PdfViewerComponent
                      ref={pdfViewerRef}
                      BatchID="0"
                      BatchDocumentID={selectedDoc.batchDocumentID}
                      origin="DocumentSearch"
                      id="documentViewerVwr"
                      name="documentViewerVwr"
                      key={uncDocumentUrl}
                      document={uncDocumentUrl}
                      documentId={selectedDoc.batchDocumentID}
                      onSplitButtonPress={handleSplitButtonPress}
                      onSplitAllButtonPress={handleSplitAllButtonPress}
                      onSaveRotateButtonPress={handleSaveRotateButtonPress}
                      onSaveAsButtonPress={handleSaveAsButtonPress}
                      onDeleteButtonPress={handleDeleteButtonPress}
                      onCopyPathButtonPress={handleCopyPathButtonPress}
                      viewerAccessPermissions={documentViewerAccessPermissions}
                      onPDFReadError={handlePDFViewerError}
                      onEditorCloseRequest={handleDocumentEditorCloseRequest}
                />
                  </div>
                )}
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
  );

  return (
    <div>
      <ToggleSplitPane
        leftPaneTitle={leftPaneTitle}
        leftPaneContent={leftPaneContent}
        rightPaneTitle={rightPaneTitle}
        rightPaneContent={rightPaneContent}
        leftPaneSize='50%'
      >
      </ToggleSplitPane>

      <AlertNotification
        alertType={alertProps.type}
        message={alertProps.message}
        open={alertProps.open}
        onClose={handleAlertClose}
      />


      {/* Include the Confirmation Dialog component */}
      <ConfirmationDialog
        openConfirmation={confirmDialogOpen}
        dialogContent={confirmationDialogContent}
        onCloseConfirmation={handleCloseConfirmDialog}
        onConfirmDialog={(param) => handleDialogConfirmAction(param)}
      />

      {/* Include the Notification Dialog component */}
      <NotificationDialog
        openNotification={notificationDialogOpen}
        dialogContent={notificationDialogContent}
        onCloseNotification={handleCloseNotificationDialog}
        isAutoClose={timerAutoCloseNotificationDialog}
        timerDuration={timerNotificationDialogClose}
        position={notificationDialogPosition || "center"}
      />

      {/* Include the loader component */}
      <PageLoader isPageLoading={isPageLoading} />
    </div>
  );
};

export default DocumentSearch;
